/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 * 
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 * 
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.OktaAuth = t() : e.OktaAuth = t();
}(window, function () {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 38);
  }([function (e, t, n) {
    "use strict";

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */
    function r(e) {
      return o(btoa(e));
    }
    function o(e) {
      return e.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    }
    function i(e) {
      return e.replace(/-/g, "+").replace(/_/g, "/");
    }
    function a(e) {
      var t = i(e);
      switch (t.length % 4) {
        case 0:
          break;
        case 2:
          t += "==";
          break;
        case 3:
          t += "=";
          break;
        default:
          throw "Not a valid Base64Url";
      }
      var n = atob(t);
      try {
        return decodeURIComponent(escape(n));
      } catch (e) {
        return n;
      }
    }
    function s(e) {
      for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) {
        t[n] = e.charCodeAt(n);
      }
      return t;
    }
    function u(e) {
      return atob(i(e));
    }
    function c(e, t) {
      var n = Array.prototype.slice.call(arguments, 2);
      return function () {
        var r = Array.prototype.slice.call(arguments);
        return r = n.concat(r), e.apply(t, r);
      };
    }
    function f(e) {
      return /^(?:[a-z]+:)?\/\//i.test(e);
    }
    function l() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
        t = arguments.length > 1 ? arguments[1] : void 0;
      return f(e) ? e : (t = R(t), "/" === e[0] ? "".concat(t).concat(e) : "".concat(t, "/").concat(e));
    }
    function d() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
        t = arguments.length > 1 ? arguments[1] : void 0;
      return f(e) && (e = e.substring(t.length)), "/" === e[0] ? e : "/".concat(e);
    }
    function h(e) {
      return "[object String]" === Object.prototype.toString.call(e);
    }
    function p(e) {
      return "[object Object]" === Object.prototype.toString.call(e);
    }
    function g(e) {
      return "[object Number]" === Object.prototype.toString.call(e);
    }
    function v(e) {
      var t = e.match(/\d+/g),
        n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
      return new Date(n).toUTCString();
    }
    function y(e) {
      var t = [];
      if (null !== e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && void 0 !== e[n] && null !== e[n] && t.push(n + "=" + encodeURIComponent(e[n]));
      }
      return t.length ? "?" + t.join("&") : "";
    }
    function m(e) {
      for (var t = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", n = "", r = 0, o = t.length; r < e; ++r) {
        n += t[Math.floor(Math.random() * o)];
      }
      return n;
    }
    function b() {
      var e = arguments[0],
        t = [].slice.call(arguments, 1);
      return t.forEach(function (t) {
        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e[n] = t[n]);
        }
      }), e;
    }
    function k(e) {
      var t = {};
      for (var n in e) {
        if (Object.prototype.hasOwnProperty.call(e, n)) {
          var r = e[n];
          null != r && (t[n] = r);
        }
      }
      return t;
    }
    function w(e) {
      if (e) {
        var t = JSON.stringify(e);
        if (t) return JSON.parse(t);
      }
      return e;
    }
    function T(e) {
      for (var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
        r[o - 1] = arguments[o];
      }
      for (var i in e) {
        Object.prototype.hasOwnProperty.call(e, i) && -1 == r.indexOf(i) && (t[i] = e[i]);
      }
      return w(t);
    }
    function O(e, t) {
      for (var n = e.length; n--;) {
        var r = e[n],
          o = !0;
        for (var i in t) {
          if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
            o = !1;
            break;
          }
        }
        if (o) return r;
      }
    }
    function S(e, t, n) {
      if (e && e._links) {
        var r = w(e._links[t]);
        return r && r.name && n ? r.name === n ? r : void 0 : r;
      }
    }
    function _() {
      return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
    }
    function E() {
      var e = _();
      return e && e.log ? e : {
        log: function log() {},
        warn: function warn() {},
        group: function group() {},
        groupEnd: function groupEnd() {}
      };
    }
    function A(e) {
      E().warn("[okta-auth-sdk] WARN: " + e);
    }
    function x(e) {
      E().warn("[okta-auth-sdk] DEPRECATION: " + e);
    }
    function j(e, t) {
      return function () {
        return x(e), t.apply(null, arguments);
      };
    }
    function R(e) {
      if (e) {
        var t = e.replace(/^\s+|\s+$/gm, "");
        return t = t.replace(/\/+$/, "");
      }
    }
    function P() {
      return !!document.documentMode && document.documentMode <= 11;
    }
    function U(e) {
      return !!e && "[object Function]" === {}.toString.call(e);
    }
    function C(e) {
      return new Promise(function (t) {
        setTimeout(t, e);
      });
    }
    function I(e) {
      return e && e.finally && "function" == typeof e.finally;
    }
    n.d(t, "A", function () {
      return r;
    }), n.d(t, "a", function () {
      return o;
    }), n.d(t, "c", function () {
      return i;
    }), n.d(t, "d", function () {
      return a;
    }), n.d(t, "B", function () {
      return s;
    }), n.d(t, "b", function () {
      return u;
    }), n.d(t, "e", function () {
      return c;
    }), n.d(t, "p", function () {
      return f;
    }), n.d(t, "C", function () {
      return l;
    }), n.d(t, "E", function () {
      return d;
    }), n.d(t, "v", function () {
      return h;
    }), n.d(t, "t", function () {
      return p;
    }), n.d(t, "s", function () {
      return g;
    }), n.d(t, "w", function () {
      return v;
    }), n.d(t, "D", function () {
      return y;
    }), n.d(t, "l", function () {
      return m;
    }), n.d(t, "j", function () {
      return b;
    }), n.d(t, "y", function () {
      return k;
    }), n.d(t, "f", function () {
      return w;
    }), n.d(t, "x", function () {
      return T;
    }), n.d(t, "k", function () {
      return O;
    }), n.d(t, "n", function () {
      return S;
    }), n.d(t, "o", function () {
      return _;
    }), n.d(t, "m", function () {
      return E;
    }), n.d(t, "F", function () {
      return A;
    }), n.d(t, "h", function () {
      return x;
    }), n.d(t, "i", function () {
      return j;
    }), n.d(t, "z", function () {
      return R;
    }), n.d(t, "r", function () {
      return P;
    }), n.d(t, "q", function () {
      return U;
    }), n.d(t, "g", function () {
      return C;
    }), n.d(t, "u", function () {
      return I;
    });
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return d;
    });
    var r = n(3),
      o = n.n(r),
      i = n(10),
      a = n.n(i),
      s = n(11),
      u = n.n(s),
      c = n(8),
      f = n.n(c);
    function l(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */();
      return function () {
        var n,
          r = f()(e);
        if (t) {
          var o = f()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return u()(this, n);
      };
    }
    var d = function (e) {
      a()(n, e);
      var t = l(n);
      function n(e, r) {
        var i;
        return o()(this, n), (i = t.call(this, e)).name = "AuthSdkError", i.errorCode = "INTERNAL", i.errorSummary = e, i.errorLink = "INTERNAL", i.errorId = "INTERNAL", i.errorCauses = [], r && (i.xhr = r), i;
      }
      return n;
    }(n(16).a);
  }, function (e, t, n) {
    "use strict";

    n.d(t, "m", function () {
      return r;
    }), n.d(t, "e", function () {
      return o;
    }), n.d(t, "d", function () {
      return i;
    }), n.d(t, "c", function () {
      return a;
    }), n.d(t, "i", function () {
      return s;
    }), n.d(t, "j", function () {
      return u;
    }), n.d(t, "h", function () {
      return c;
    }), n.d(t, "n", function () {
      return f;
    }), n.d(t, "b", function () {
      return l;
    }), n.d(t, "g", function () {
      return d;
    }), n.d(t, "a", function () {
      return h;
    }), n.d(t, "f", function () {
      return p;
    }), n.d(t, "l", function () {
      return g;
    }), n.d(t, "k", function () {
      return v;
    });
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */
    var r = "oktaStateToken",
      o = 500,
      i = 300,
      a = 86400,
      s = "okta-oauth-redirect-params",
      u = "okta-oauth-state",
      c = "okta-oauth-nonce",
      f = "okta-token-storage",
      l = "okta-cache-storage",
      d = "okta-pkce-storage",
      h = "accessToken",
      p = "idToken",
      g = "refreshToken",
      v = "referrerPath";
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
      o = n(21),
      i = n(2);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
    function a(e, t) {
      var n = (t = t || {}).url,
        a = t.method,
        s = t.args,
        u = t.saveAuthnState,
        c = t.accessToken,
        f = !1 !== t.withCredentials,
        l = e.options.storageUtil,
        d = l.storage,
        h = l.getHttpCache(e.options.cookies);
      if (t.cacheResponse) {
        var p = h.getStorage()[n];
        if (p && Date.now() / 1e3 < p.expiresAt) return Promise.resolve(p.response);
      }
      var g = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Okta-User-Agent-Extended": e.userAgent
      };
      Object.assign(g, e.options.headers, t.headers), g = Object(r.y)(g), c && Object(r.v)(c) && (g.Authorization = "Bearer " + c);
      var v,
        y,
        m = {
          headers: g,
          data: s || void 0,
          withCredentials: f
        };
      return e.options.httpRequestClient(a, n, m).then(function (o) {
        return (y = o.responseText) && Object(r.v)(y) && (y = JSON.parse(y)), u && (y.stateToken || d.delete(i.m)), y && y.stateToken && y.expiresAt && d.set(i.m, y.stateToken, y.expiresAt, e.options.cookies), y && t.cacheResponse && h.updateStorage(n, {
          expiresAt: Math.floor(Date.now() / 1e3) + i.c,
          response: y
        }), y;
      }).catch(function (t) {
        var n = t.responseText || {};
        if (Object(r.v)(n)) try {
          n = JSON.parse(n);
        } catch (e) {
          n = {
            errorSummary: "Unknown error"
          };
        }
        throw t.status >= 500 && (n.errorSummary = "Unknown error"), e.options.transformErrorXHR && (t = e.options.transformErrorXHR(Object(r.f)(t))), "E0000011" === (v = new o.a(n, t)).errorCode && d.delete(i.m), v;
      });
    }
    t.a = {
      get: function get(e, t, n) {
        var o = {
          url: t = Object(r.p)(t) ? t : e.getIssuerOrigin() + t,
          method: "GET"
        };
        return Object.assign(o, n), a(e, o);
      },
      post: function post(e, t, n, o) {
        var i = {
          url: t = Object(r.p)(t) ? t : e.getIssuerOrigin() + t,
          method: "POST",
          args: n,
          saveAuthnState: !0
        };
        return Object.assign(i, o), a(e, i);
      },
      httpRequest: a
    };
  }, function (e, t, n) {
    e.exports = n(39);
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(15),
      o = n(2),
      i = n(1),
      a = n(43),
      s = {
        browserHasLocalStorage: function browserHasLocalStorage() {
          try {
            var e = s.getLocalStorage();
            return s.testStorage(e);
          } catch (e) {
            return !1;
          }
        },
        browserHasSessionStorage: function browserHasSessionStorage() {
          try {
            var e = s.getSessionStorage();
            return s.testStorage(e);
          } catch (e) {
            return !1;
          }
        },
        getPKCEStorage: function getPKCEStorage(e) {
          return !(e = e || {}).preferLocalStorage && s.browserHasSessionStorage() ? Object(r.a)(s.getSessionStorage(), o.g) : s.browserHasLocalStorage() ? Object(r.a)(s.getLocalStorage(), o.g) : Object(r.a)(s.getCookieStorage(e), o.g);
        },
        getHttpCache: function getHttpCache(e) {
          return s.browserHasLocalStorage() ? Object(r.a)(s.getLocalStorage(), o.b) : s.browserHasSessionStorage() ? Object(r.a)(s.getSessionStorage(), o.b) : Object(r.a)(s.getCookieStorage(e), o.b);
        },
        getLocalStorage: function getLocalStorage() {
          return localStorage;
        },
        getSessionStorage: function getSessionStorage() {
          return sessionStorage;
        },
        getCookieStorage: function getCookieStorage(e) {
          var t = e.secure,
            n = e.sameSite;
          if (void 0 === t || void 0 === n) throw new i.a('getCookieStorage: "secure" and "sameSite" options must be provided');
          return {
            getItem: s.storage.get,
            setItem: function setItem(e, r) {
              s.storage.set(e, r, "2200-01-01T00:00:00.000Z", {
                secure: t,
                sameSite: n
              });
            }
          };
        },
        getInMemoryStorage: function getInMemoryStorage() {
          var e = {};
          return {
            getItem: function getItem(t) {
              return e[t];
            },
            setItem: function setItem(t, n) {
              e[t] = n;
            }
          };
        },
        testStorage: function testStorage(e) {
          var t = "okta-test-storage";
          try {
            return e.setItem(t, t), e.removeItem(t), !0;
          } catch (e) {
            return !1;
          }
        },
        storage: {
          set: function set(e, t, n, r) {
            var o = r.secure,
              u = r.sameSite;
            if (void 0 === o || void 0 === u) throw new i.a('storage.set: "secure" and "sameSite" options must be provided');
            var c = {
              path: r.path || "/",
              secure: o,
              sameSite: u
            };
            return Date.parse(n) && (c.expires = new Date(n)), a.set(e, t, c), s.storage.get(e);
          },
          get: function get(e) {
            return a.get(e);
          },
          delete: function _delete(e) {
            return a.remove(e, {
              path: "/"
            });
          }
        }
      };
    t.a = s;
  }, function (e, t) {
    function n(t) {
      return e.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, n(t);
    }
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(25);
    for (var o in r) {
      "default" !== o && function (e) {
        n.d(t, e, function () {
          return r[e];
        });
      }(o);
    }
    var i = n(26);
    for (var o in i) {
      "default" !== o && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(o);
    }
    var a = n(27);
    for (var o in a) {
      "default" !== o && function (e) {
        n.d(t, e, function () {
          return a[e];
        });
      }(o);
    }
    var s = n(28);
    for (var o in s) {
      "default" !== o && function (e) {
        n.d(t, e, function () {
          return s[e];
        });
      }(o);
    }
    var u = n(29);
    for (var o in u) {
      "default" !== o && function (e) {
        n.d(t, e, function () {
          return u[e];
        });
      }(o);
    }
    var c = n(30);
    for (var o in c) {
      "default" !== o && function (e) {
        n.d(t, e, function () {
          return c[e];
        });
      }(o);
    }
    var f = n(31);
    for (var o in f) {
      "default" !== o && function (e) {
        n.d(t, e, function () {
          return f[e];
        });
      }(o);
    }
    var l = n(32);
    n.d(t, "isToken", function () {
      return l.d;
    }), n.d(t, "isAccessToken", function () {
      return l.a;
    }), n.d(t, "isIDToken", function () {
      return l.b;
    }), n.d(t, "isRefreshToken", function () {
      return l.c;
    });
    var d = n(33);
    for (var o in d) {
      ["isToken", "isAccessToken", "isIDToken", "isRefreshToken", "default"].indexOf(o) < 0 && function (e) {
        n.d(t, e, function () {
          return d[e];
        });
      }(o);
    }
    var h = n(34);
    for (var o in h) {
      ["isToken", "isAccessToken", "isIDToken", "isRefreshToken", "default"].indexOf(o) < 0 && function (e) {
        n.d(t, e, function () {
          return h[e];
        });
      }(o);
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */
  }, function (e, t, n) {
    var r = n(23);
    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && r(e, t);
    };
  }, function (e, t, n) {
    var r = n(18),
      o = n(6);
    e.exports = function (e, t) {
      return !t || "object" !== r(t) && "function" != typeof t ? o(e) : t;
    };
  }, function (e, t, n) {
    "use strict";

    n.d(t, "j", function () {
      return v;
    }), n.d(t, "h", function () {
      return y;
    }), n.d(t, "i", function () {
      return b;
    }), n.d(t, "g", function () {
      return k;
    }), n.d(t, "f", function () {
      return m;
    }), n.d(t, "a", function () {
      return h;
    }), n.d(t, "d", function () {
      return d;
    }), n.d(t, "b", function () {
      return w;
    }), n.d(t, "c", function () {
      return a;
    }), n.d(t, "e", function () {
      return s;
    });
    var r = n(4),
      o = n(1),
      i = n(2);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
    function a(e, t) {
      var n = {};
      return Object.assign(n, t), !n.stateToken && e.stateToken && (n.stateToken = e.stateToken), n;
    }
    function s(e) {
      return a(e);
    }
    var u = n(3),
      c = n.n(u),
      f = n(0),
      l = n(19);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
    function d(e, t, n) {
      return function (a) {
        var u, c, d, p;
        Object(f.s)(a) ? u = a : Object(f.t)(a) && (u = (a = a).delay, c = a.rememberDevice, d = a.autoPush, p = a.transactionCallBack), u || 0 === u || (u = i.e);
        var g = Object(f.n)(t, "next", "poll");
        n.isPolling = !0;
        var v = 0;
        return function i() {
          return n.isPolling ? function () {
            var n = {};
            if ("function" == typeof d) try {
              n.autoPush = !!d();
            } catch (e) {
              return Promise.reject(new o.a("AutoPush resulted in an error."));
            } else null != d && (n.autoPush = !!d);
            if ("function" == typeof c) try {
              n.rememberDevice = !!c();
            } catch (e) {
              return Promise.reject(new o.a("RememberDevice resulted in an error."));
            } else null != c && (n.rememberDevice = !!c);
            var i = g.href + Object(f.D)(n);
            return r.a.post(e, i, s(t), {
              saveAuthnState: !1
            });
          }().then(function (t) {
            if (v = 0, t.factorResult && "WAITING" === t.factorResult) {
              if (!n.isPolling) throw new l.a();
              return "function" == typeof p && p(t), Object(f.g)(u).then(i);
            }
            return n.isPolling = !1, new h(e, t);
          }).catch(function (e) {
            if (e.xhr && (0 === e.xhr.status || 429 === e.xhr.status) && v <= 4) {
              var t = 1e3 * Math.pow(2, v);
              return v++, Object(f.g)(t).then(i);
            }
            throw e;
          }) : Promise.reject(new l.a());
        }().catch(function (e) {
          throw n.isPolling = !1, e;
        });
      };
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
    var h = function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      c()(this, e), n && (this.data = n, Object.assign(this, g(t, n, n, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== n.status || n._links || (this.cancel = function () {
        return Promise.resolve(new e(t));
      }));
    };
    function p(e, t, n, i, s) {
      if (Array.isArray(i)) return function (r, a) {
        if (!r) throw new o.a("Must provide a link name");
        var u = Object(f.k)(i, {
          name: r
        });
        if (!u) throw new o.a("No link found for that name");
        return p(e, t, n, u, s)(a);
      };
      if (i.hints && i.hints.allow && 1 === i.hints.allow.length) switch (i.hints.allow[0]) {
        case "GET":
          return function () {
            return r.a.get(e, i.href);
          };
        case "POST":
          return function (r) {
            s && s.isPolling && (s.isPolling = !1);
            var u = a(t, r);
            "MFA_ENROLL" !== t.status && "FACTOR_ENROLL" !== t.status || Object.assign(u, {
              factorType: n.factorType,
              provider: n.provider
            });
            var c = {},
              l = u.autoPush;
            if (void 0 !== l) {
              if ("function" == typeof l) try {
                c.autoPush = !!l();
              } catch (e) {
                return Promise.reject(new o.a("AutoPush resulted in an error."));
              } else null !== l && (c.autoPush = !!l);
              u = Object(f.x)(u, "autoPush");
            }
            var d = u.rememberDevice;
            if (void 0 !== d) {
              if ("function" == typeof d) try {
                c.rememberDevice = !!d();
              } catch (e) {
                return Promise.reject(new o.a("RememberDevice resulted in an error."));
              } else null !== d && (c.rememberDevice = !!d);
              u = Object(f.x)(u, "rememberDevice");
            } else u.profile && void 0 !== u.profile.updatePhone && (u.profile.updatePhone && (c.updatePhone = !0), u.profile = Object(f.x)(u.profile, "updatePhone"));
            var h = i.href + Object(f.D)(c);
            return k(e, h, u);
          };
      }
    }
    function g(e, t, n, r) {
      if (n = n || t, n = Object(f.f)(n), Array.isArray(n)) {
        for (var o = [], i = 0, a = n.length; i < a; i++) {
          o.push(g(e, t, n[i], r));
        }
        return o;
      }
      var s = n._embedded || {};
      for (var u in s) {
        Object.prototype.hasOwnProperty.call(s, u) && (Object(f.t)(s[u]) || Array.isArray(s[u])) && (s[u] = g(e, t, s[u], r));
      }
      var c = function (e, t, n, r) {
        var o = {};
        for (var i in n._links) {
          if (Object.prototype.hasOwnProperty.call(n._links, i)) {
            var a = n._links[i];
            if ("next" === i && (i = a.name), a.type) o[i] = a;else switch (i) {
              case "poll":
                o.poll = d(e, t, r);
                break;
              default:
                var s = p(e, t, n, a, r);
                s && (o[i] = s);
            }
          }
        }
        return o;
      }(e, t, n, r);
      return Object.assign(s, c), n = Object(f.x)(n, "_embedded", "_links"), Object.assign(n, s), n;
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
    function v(e, t) {
      return t = a(e, t), r.a.post(e, e.getIssuerOrigin() + "/api/v1/authn", t);
    }
    function y(e, t) {
      if (!t || !t.stateToken) {
        var n = e.tx.exists._get(i.m);
        if (!n) return Promise.reject(new o.a("No transaction to resume"));
        t = {
          stateToken: n
        };
      }
      return e.tx.status(t).then(function (t) {
        return new h(e, t);
      });
    }
    function m(e, t) {
      if (!t || !t.stateToken) {
        var n = e.tx.exists._get(i.m);
        if (!n) return Promise.reject(new o.a("No transaction to evaluate"));
        t = {
          stateToken: n
        };
      }
      return function (e, t) {
        return t = a(e, t), r.a.post(e, e.getIssuerOrigin() + "/api/v1/authn/introspect", t);
      }(e, t).then(function (t) {
        return new h(e, t);
      });
    }
    function b(e) {
      return !!e.tx.exists._get(i.m);
    }
    function k(e, t, n, o) {
      return r.a.post(e, t, n, o).then(function (t) {
        return new h(e, t);
      });
    }
    var w = function e() {
      c()(this, e);
    };
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    e.exports = function (e, t, r) {
      return t && n(e.prototype, t), r && n(e, r), e;
    };
  }, function (e, t, n) {
    "use strict";

    n.d(t, "c", function () {
      return b;
    }), n.d(t, "e", function () {
      return k;
    }), n.d(t, "a", function () {
      return w;
    }), n.d(t, "d", function () {
      return T;
    }), n.d(t, "b", function () {
      return O;
    }), n.d(t, "f", function () {
      return W;
    });
    var r = n(18),
      o = n.n(r),
      i = n(3),
      a = n.n(i),
      s = n(22),
      u = n.n(s),
      c = n(0),
      f = n(1),
      l = n(7),
      d = n(2),
      h = n(15),
      p = n(13),
      g = n.n(p),
      v = function () {
        function e(t) {
          a()(this, e), this.localOffset = parseInt(t || 0);
        }
        return g()(e, [{
          key: "now",
          value: function value() {
            var e = (Date.now() + this.localOffset) / 1e3;
            return e;
          }
        }], [{
          key: "create",
          value: function value() {
            return new e(0);
          }
        }]), e;
      }(),
      y = n(9),
      m = {
        autoRenew: !0,
        autoRemove: !0,
        storage: "localStorage",
        expireEarlySeconds: 30,
        storageKey: d.n,
        _storageEventDelay: 0
      },
      b = "expired",
      k = "renewed",
      w = "added",
      T = "removed",
      O = "error";
    function S(e, t) {
      return t.expiresAt - e.options.expireEarlySeconds;
    }
    function _(e, t) {
      return S(e, t) <= e.clock.now();
    }
    function E(e, t, n, r) {
      e.emitter.emit(k, t, n, r);
    }
    function A(e, t, n) {
      e.emitter.emit(w, t, n);
    }
    function x(e, t, n) {
      e.emitter.emit(T, t, n);
    }
    function j(e, t) {
      e.emitter.emit(O, t);
    }
    function R(e, t, n) {
      var r = V(n),
        o = V(t);
      Object.keys(o).forEach(function (t) {
        var n = r[t],
          i = o[t];
        JSON.stringify(n) !== JSON.stringify(i) && A(e, t, i);
      }), Object.keys(r).forEach(function (t) {
        var n = r[t];
        o[t] || x(e, t, n);
      });
    }
    function P(e, t) {
      clearTimeout(e.expireTimeouts[t]), delete e.expireTimeouts[t], delete e.renewPromise[t];
    }
    function U(e) {
      var t = e.expireTimeouts;
      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && P(e, n);
      }
    }
    function C(e, t, n, r) {
      var o = S(t, r),
        i = 1e3 * Math.max(o - t.clock.now(), 0);
      P(t, n);
      var a = setTimeout(function () {
        !function (e, t, n) {
          e.emitter.emit(b, t, n);
        }(t, n, r);
      }, i);
      t.expireTimeouts[n] = a;
    }
    function I(e, t, n) {
      try {
        var r = n.getStorage();
      } catch (e) {
        return void j(t, e);
      }
      for (var o in r) {
        if (Object.prototype.hasOwnProperty.call(r, o)) C(0, t, o, r[o]);
      }
    }
    function M(e, t, n) {
      U(t), I(0, t, n);
    }
    function D(e) {
      if (!Object(c.t)(e) || !e.scopes || !e.expiresAt && 0 !== e.expiresAt || !Object(y.isIDToken)(e) && !Object(y.isAccessToken)(e) && !Object(y.isRefreshToken)(e)) throw new f.a("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
    }
    function L(e, t, n, r, o) {
      e.features.isLocalhost() && Object(c.F)("Use setTokens() instead if you want to add a set of tokens at same time.\nIt prevents current tab from emitting unnecessary StorageEvent,\nwhich may cause false-positive authState change cross tabs.");
      var i = n.getStorage();
      D(o), i[r] = o, n.setStorage(i), A(t, r, o), C(0, t, r, o);
    }
    function N(e, t) {
      return e.getStorage()[t];
    }
    function F(e, t) {
      var n = e.getStorage();
      return Object.keys(n).filter(function (e) {
        var r = n[e];
        return Object(y.isAccessToken)(r) && "accessToken" === t || Object(y.isIDToken)(r) && "idToken" === t || Object(y.isRefreshToken)(r) && "refreshToken" === t;
      })[0];
    }
    function H(e, t) {
      return new Promise(function (n) {
        return n(N(e, t));
      });
    }
    function K(e) {
      var t = {},
        n = e.getStorage();
      return Object.keys(n).forEach(function (e) {
        var r = n[e];
        Object(y.isAccessToken)(r) ? t.accessToken = r : Object(y.isIDToken)(r) ? t.idToken = r : Object(y.isRefreshToken)(r) && (t.refreshToken = r);
      }), t;
    }
    function B(e) {
      return new Promise(function (t) {
        return t(K(e));
      });
    }
    function q(e, t, n, r, o, i, a) {
      var s = r.accessToken,
        c = r.idToken,
        f = r.refreshToken,
        l = function l(e, n, r) {
          A(t, e, n), C(0, t, e, n), r && r(e, n);
        },
        h = function h(e, n, r) {
          P(t, e), x(t, e, n), r && r(e, n);
        };
      c && D(c), s && D(s);
      var p = F(n, "idToken") || d.f,
        g = F(n, "accessToken") || d.a,
        v = F(n, "refreshToken") || d.l,
        y = Object.assign(Object.assign(Object.assign({}, c && u()({}, p, c)), s && u()({}, g, s)), f && u()({}, v, f));
      n.setStorage(y);
      var m = K(n);
      c ? l(p, c, i) : m.idToken && h(p, m.idToken, i), s ? l(g, s, o) : m.accessToken && h(g, m.accessToken, o), f ? l(v, f, a) : m.refreshToken && h(v, m.refreshToken, a);
    }
    function z(e, t, n) {
      P(e, n);
      var r = t.getStorage(),
        o = r[n];
      delete r[n], t.setStorage(r), x(e, n, o);
    }
    function J(e, t, n, r) {
      var o = t.renewPromise[r];
      if (o) return o;
      try {
        var i = N(n, r);
        if (!i) throw new f.a("The tokenManager has no token for the key: " + r);
      } catch (e) {
        return Promise.reject(e);
      }
      return U(t), t.renewPromise[r] = e.token.renewTokens({
        scopes: i.scopes
      }).then(function (e) {
        var o = n.getStorage();
        return q(0, t, n, e, function (e, n) {
          return E(t, e, n, o[e]);
        }, function (e, n) {
          return E(t, e, n, o[e]);
        }), N(n, r);
      }).catch(function (e) {
        if ("OAuthError" === e.name || "AuthSdkError" === e.name) {
          var o = [],
            i = n.getStorage();
          Object.keys(i).forEach(function (e) {
            var n = i[e];
            n && _(t, n) && (delete i[e], o.push({
              key: e,
              token: n
            }), P(t, e));
          }), n.setStorage(i), o.length ? o.forEach(function (e, n) {
            return x(t, e, n);
          }) : (x(t, d.f), x(t, d.a)), e.tokenKey = r, j(t, e);
        }
        throw e;
      }).finally(function () {
        delete t.renewPromise[r];
      }), t.renewPromise[r];
    }
    function G(e, t) {
      U(e), t.clearStorage();
    }
    function V(e) {
      var t;
      try {
        t = JSON.parse(e) || {};
      } catch (e) {
        t = {};
      }
      return t;
    }
    var W = function e(t, n) {
      var r,
        i = this;
      if (a()(this, e), n = Object.assign({}, m, Object(c.y)(n)), !t.emitter) throw new f.a("Emitter should be initialized before TokenManager");
      if ("localStorage" !== n.storage || l.a.browserHasLocalStorage() || (Object(c.F)("This browser doesn't support localStorage. Switching to sessionStorage."), n.storage = "sessionStorage"), "sessionStorage" !== n.storage || l.a.browserHasSessionStorage() || (Object(c.F)("This browser doesn't support sessionStorage. Switching to cookie-based storage."), n.storage = "cookie"), Object(c.r)() && (n._storageEventDelay = n._storageEventDelay || 1e3), "object" === o()(n.storage)) r = n.storage;else switch (n.storage) {
        case "localStorage":
          r = localStorage;
          break;
        case "sessionStorage":
          r = sessionStorage;
          break;
        case "cookie":
          r = function (e) {
            var t = l.a.getCookieStorage(e);
            return {
              getItem: function getItem(e) {
                var n = t.getItem(),
                  r = {};
                return Object.keys(n).forEach(function (t) {
                  0 === t.indexOf(e) && (r[t.replace("".concat(e, "_"), "")] = JSON.parse(n[t]));
                }), JSON.stringify(r);
              },
              setItem: function setItem(e, n) {
                var r = JSON.parse(this.getItem(e));
                n = JSON.parse(n), Object.keys(n).forEach(function (o) {
                  var i = e + "_" + o,
                    a = JSON.stringify(n[o]);
                  t.setItem(i, a), delete r[o];
                }), Object.keys(r).forEach(function (t) {
                  l.a.storage.delete(e + "_" + t);
                });
              }
            };
          }(t.options.cookies);
          break;
        case "memory":
          r = l.a.getInMemoryStorage();
          break;
        default:
          throw new f.a("Unrecognized storage option");
      }
      var s = Object(h.a)(r, n.storageKey),
        u = {
          clock: v.create(),
          options: n,
          emitter: t.emitter,
          expireTimeouts: {},
          renewPromise: {}
        };
      this.add = L.bind(this, t, u, s), this.get = H.bind(this, s), this.remove = z.bind(this, u, s), this.clear = G.bind(this, u, s), this.renew = J.bind(this, t, u, s), this.on = u.emitter.on.bind(u.emitter), this.off = u.emitter.off.bind(u.emitter), this.hasExpired = _.bind(this, u), this.getTokens = B.bind(this, s), this.setTokens = q.bind(this, t, u, s), this._getStorageKeyByType = F.bind(this, s), this._clearExpireEventTimeoutAll = U.bind(this, u), this._getOptions = function () {
        return Object(c.f)(n);
      }, this._resetExpireEventTimeoutAll = M.bind(this, t, u, s), this._emitEventsForCrossTabsStorageUpdate = R.bind(this, u);
      var d = [];
      this.on(b, function (e) {
        if (n.autoRenew) {
          if (function (e) {
            var t = !1;
            if (e.push(Date.now()), e.length >= 10) {
              var n = e.shift();
              t = e[e.length - 1] - n < 3e4;
            }
            return t;
          }(d)) {
            var t = new f.a("Too many token renew requests");
            j(u, t);
          } else i.renew(e).catch(function () {});
        } else n.autoRemove && i.remove(e);
      }), I(0, u, s), window.addEventListener("storage", function (e) {
        var t = e.key,
          r = e.newValue,
          o = e.oldValue;
        (!t || t === n.storageKey && r !== o) && setTimeout(function () {
          return i._resetExpireEventTimeoutAll(), void i._emitEventsForCrossTabsStorageUpdate(r, o);
        }, n._storageEventDelay);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(1);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
    t.a = function (e, t) {
      if ("string" != typeof t || !t.length) throw new r.a('"storageName" is required');
      function n() {
        var n = e.getItem(t);
        n = n || "{}";
        try {
          return JSON.parse(n);
        } catch (e) {
          throw new r.a("Unable to parse storage string: " + t);
        }
      }
      function o(n) {
        try {
          var o = JSON.stringify(n);
          e.setItem(t, o);
        } catch (e) {
          throw new r.a("Unable to set storage: " + t);
        }
      }
      return {
        getStorage: n,
        setStorage: o,
        clearStorage: function clearStorage(e) {
          if (!e) return o({});
          var t = n();
          delete t[e], o(t);
        },
        updateStorage: function updateStorage(e, t) {
          var r = n();
          r[e] = t, o(r);
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return g;
    });
    var r = n(3),
      o = n.n(r),
      i = n(6),
      a = n.n(i),
      s = n(10),
      u = n.n(s),
      c = n(11),
      f = n.n(c),
      l = n(8),
      d = n.n(l),
      h = n(24);
    function p(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */();
      return function () {
        var n,
          r = d()(e);
        if (t) {
          var o = d()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return f()(this, n);
      };
    }
    var g = function (e) {
      u()(n, e);
      var t = p(n);
      function n(e) {
        var r;
        return o()(this, n), r = t.call(this, e), Object.setPrototypeOf(a()(r), (this instanceof n ? this.constructor : void 0).prototype), r;
      }
      return n;
    }(n.n(h)()(Error));
  }, function (e, t, n) {
    "use strict";

    var r = n(21);
    n.d(t, "a", function () {
      return r.a;
    });
    var o = n(19);
    n.d(t, "b", function () {
      return o.a;
    });
    var i = n(1);
    n.d(t, "c", function () {
      return i.a;
    });
    var a = n(20);
    n.d(t, "d", function () {
      return a.a;
    });
  }, function (e, t) {
    function n(t) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = n = function n(e) {
        return typeof e;
      } : e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, n(t);
    }
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return d;
    });
    var r = n(3),
      o = n.n(r),
      i = n(10),
      a = n.n(i),
      s = n(11),
      u = n.n(s),
      c = n(8),
      f = n.n(c);
    function l(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */();
      return function () {
        var n,
          r = f()(e);
        if (t) {
          var o = f()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return u()(this, n);
      };
    }
    var d = function (e) {
      a()(n, e);
      var t = l(n);
      function n() {
        o()(this, n);
        return t.call(this, "The poll was stopped by the sdk");
      }
      return n;
    }(n(16).a);
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return d;
    });
    var r = n(3),
      o = n.n(r),
      i = n(10),
      a = n.n(i),
      s = n(11),
      u = n.n(s),
      c = n(8),
      f = n.n(c);
    function l(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */();
      return function () {
        var n,
          r = f()(e);
        if (t) {
          var o = f()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return u()(this, n);
      };
    }
    var d = function (e) {
      a()(n, e);
      var t = l(n);
      function n(e, r) {
        var i;
        return o()(this, n), (i = t.call(this, r)).name = "OAuthError", i.errorCode = e, i.errorSummary = r, i;
      }
      return n;
    }(n(16).a);
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return d;
    });
    var r = n(3),
      o = n.n(r),
      i = n(10),
      a = n.n(i),
      s = n(11),
      u = n.n(s),
      c = n(8),
      f = n.n(c);
    function l(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */();
      return function () {
        var n,
          r = f()(e);
        if (t) {
          var o = f()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return u()(this, n);
      };
    }
    var d = function (e) {
      a()(n, e);
      var t = l(n);
      function n(e, r) {
        var i;
        o()(this, n);
        var a = e.errorSummary;
        return (i = t.call(this, a)).name = "AuthApiError", i.errorSummary = e.errorSummary, i.errorCode = e.errorCode, i.errorLink = e.errorLink, i.errorId = e.errorId, i.errorCauses = e.errorCauses, r && (i.xhr = r), i;
      }
      return n;
    }(n(16).a);
  }, function (e, t) {
    e.exports = function (e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    };
  }, function (e, t) {
    function n(t, r) {
      return e.exports = n = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, n(t, r);
    }
    e.exports = n;
  }, function (e, t, n) {
    var r = n(8),
      o = n(23),
      i = n(40),
      a = n(41);
    function s(t) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return e.exports = s = function s(e) {
        if (null === e || !i(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== n) {
          if (n.has(e)) return n.get(e);
          n.set(e, t);
        }
        function t() {
          return a(e, arguments, r(this).constructor);
        }
        return t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), o(t, e);
      }, s(t);
    }
    e.exports = s;
  }, function (e, t) {
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */}, function (e, t) {
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */}, function (e, t) {}, function (e, t) {
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */}, function (e, t) {
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */}, function (e, t) {
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */}, function (e, t) {
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */}, function (e, t, n) {
    "use strict";

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */
    function r(e) {
      return !!(e && (e.accessToken || e.idToken || e.refreshToken) && Array.isArray(e.scopes));
    }
    function o(e) {
      return e && e.accessToken;
    }
    function i(e) {
      return e && e.idToken;
    }
    function a(e) {
      return e && e.refreshToken;
    }
    n.d(t, "d", function () {
      return r;
    }), n.d(t, "a", function () {
      return o;
    }), n.d(t, "b", function () {
      return i;
    }), n.d(t, "c", function () {
      return a;
    });
  }, function (e, t) {
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */}, function (e, t) {}, function (e, t, n) {
    "use strict";

    var r = {};
    n.r(r), n.d(r, "getUserAgent", function () {
      return O;
    }), n.d(r, "isFingerprintSupported", function () {
      return S;
    }), n.d(r, "isPopupPostMessageSupported", function () {
      return _;
    }), n.d(r, "isTokenVerifySupported", function () {
      return E;
    }), n.d(r, "hasTextEncoder", function () {
      return A;
    }), n.d(r, "isPKCESupported", function () {
      return x;
    }), n.d(r, "isHTTPS", function () {
      return j;
    }), n.d(r, "isLocalhost", function () {
      return R;
    });
    var o = n(5),
      i = n.n(o),
      a = n(3),
      s = n.n(a),
      u = n(13),
      c = n.n(u),
      f = n(6),
      l = n.n(f),
      d = n(10),
      h = n.n(d),
      p = n(11),
      g = n.n(p),
      v = n(8),
      y = n.n(v),
      m = n(1);
    var b = n(0),
      k = n(12),
      w = function () {
        function e(t) {
          var n = this;
          s()(this, e),
          /*!
           * Copyright (c) 2018-present, Okta, Inc. and/or its affiliates. All rights reserved.
           * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
           *
           * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
           * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           *
           * See the License for the specific language governing permissions and limitations under the License.
           */
          function (e) {
            var t = (e = e || {}).issuer;
            if (!t) throw new m.a('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
            if (!new RegExp("^http?s?://.+").test(e.issuer)) throw new m.a('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
            if (-1 !== t.indexOf("-admin.")) throw new m.a('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
            var n = e.userAgent;
            if (n && n.template && -1 === n.template.indexOf("$OKTA_AUTH_JS")) throw new m.a('UserAgentTemplate must include "$OKTA_AUTH_JS" placeholder. Required usage: new OktaAuth({userAgentTemplate: "xxx $OKTA_AUTH_JS xxx"})');
          }(t), this.options = {
            issuer: Object(b.z)(t.issuer),
            httpRequestClient: t.httpRequestClient,
            transformErrorXHR: t.transformErrorXHR,
            storageUtil: t.storageUtil,
            headers: t.headers,
            devMode: t.devMode || !1
          }, this.tx = {
            status: k.j.bind(null, this),
            resume: k.h.bind(null, this),
            exists: Object.assign(k.i.bind(null, this), {
              _get: function _get(e) {
                return n.options.storageUtil.storage.get(e);
              }
            }),
            introspect: k.f.bind(null, this)
          };
        }
        return c()(e, [{
          key: "signIn",
          value: function value(e) {
            return Object(k.g)(this, "/api/v1/authn", e);
          }
        }, {
          key: "getIssuerOrigin",
          value: function value() {
            return this.options.issuer.split("/oauth2/")[0];
          }
        }, {
          key: "forgotPassword",
          value: function value(e) {
            return Object(k.g)(this, "/api/v1/authn/recovery/password", e);
          }
        }, {
          key: "unlockAccount",
          value: function value(e) {
            return Object(k.g)(this, "/api/v1/authn/recovery/unlock", e);
          }
        }, {
          key: "verifyRecoveryToken",
          value: function value(e) {
            return Object(k.g)(this, "/api/v1/authn/recovery/token", e);
          }
        }]), e;
      }(),
      T = /windows phone|iemobile|wpdesktop/i;
    function O() {
      return navigator.userAgent;
    }
    function S() {
      var e = O();
      return e && !T.test(e);
    }
    function _() {
      var e = document.documentMode && document.documentMode < 10;
      return !(!window.postMessage || e);
    }
    function E() {
      return "undefined" != typeof crypto && crypto.subtle && "undefined" != typeof Uint8Array;
    }
    function A() {
      return "undefined" != typeof TextEncoder;
    }
    function x() {
      return E() && A();
    }
    function j() {
      return "https:" === window.location.protocol;
    }
    function R() {
      return "localhost" === window.location.hostname;
    }
    var P = n(18),
      U = n.n(P),
      C = n(36),
      I = n.n(C);
    var M = function M(e, t, n) {
        var r = n.data,
          o = n.headers || {};
        return "application/json" === (o["Content-Type"] || o["content-type"] || "") && r && "string" != typeof r && (r = JSON.stringify(r)), I()(t, {
          method: e,
          headers: n.headers,
          body: r,
          credentials: n.withCredentials ? "include" : "omit"
        }).then(function (e) {
          var t = !e.ok,
            n = e.status;
          /*!
           * Copyright (c) 2018-present, Okta, Inc. and/or its affiliates. All rights reserved.
           * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
           *
           * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
           * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           *
           * See the License for the specific language governing permissions and limitations under the License.
           */
          return function (e) {
            return e.headers.get("Content-Type") && e.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e.json().catch(function (e) {
              return {
                error: e,
                errorSummary: "Could not parse server response"
              };
            }) : e.text();
          }(e).then(function (e) {
            return function (e, t) {
              var n = "object" === U()(t),
                r = {
                  responseText: n ? JSON.stringify(t) : t,
                  status: e
                };
              return n && (r.responseType = "json", r.responseJSON = t), r;
            }(n, e);
          }).then(function (e) {
            if (t) throw e;
            return e;
          });
        });
      },
      D = n(7),
      L = n(2),
      N = n(4);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
    function F(e) {
      return e.session.get().then(function (e) {
        return "ACTIVE" === e.status;
      }).catch(function () {
        return !1;
      });
    }
    function H(e) {
      return N.a.get(e, "/api/v1/sessions/me").then(function (t) {
        var n = Object(b.x)(t, "_links");
        return n.refresh = function () {
          return N.a.post(e, Object(b.n)(t, "refresh").href);
        }, n.user = function () {
          return N.a.get(e, Object(b.n)(t, "user").href);
        }, n;
      }).catch(function () {
        return {
          status: "INACTIVE"
        };
      });
    }
    function K(e) {
      return N.a.httpRequest(e, {
        url: e.getIssuerOrigin() + "/api/v1/sessions/me",
        method: "DELETE"
      });
    }
    function B(e) {
      return N.a.post(e, "/api/v1/sessions/me/lifecycle/refresh");
    }
    function q(e, t, n) {
      n = n || window.location.href, window.location.assign(e.getIssuerOrigin() + "/login/sessionCookieRedirect" + Object(b.D)({
        checkAccountSetupComplete: !0,
        token: t,
        redirectUrl: n
      }));
    }
    var z = n(37),
      J = n.n(z);
    function G(e, t, n) {
      e.addEventListener ? e.addEventListener(t, n) : e.attachEvent("on" + t, n);
    }
    function V(e, t, n) {
      e.removeEventListener ? e.removeEventListener(t, n) : e.detachEvent("on" + t, n);
    }
    function W(e) {
      var t = document.createElement("iframe");
      return t.style.display = "none", t.src = e, document.body.appendChild(t);
    }
    function Y(e, t) {
      var n = t.popupTitle || "External Identity Provider User Authentication",
        r = "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600";
      if (Object(b.r)()) {
        var o = window.open("/", n, r);
        return o.location.href = e, o;
      }
      return window.open(e, n, r);
    }
    function X(e, t) {
      var n = t || e.options.issuer;
      return N.a.get(e, n + "/.well-known/openid-configuration", {
        cacheResponse: !0
      });
    }
    function $(e, t) {
      if (arguments.length > 2) throw new m.a('As of version 3.0, "getOAuthUrls" takes only a single set of options');
      t = t || {};
      var n = Object(b.z)(t.authorizeUrl) || e.options.authorizeUrl,
        r = Object(b.z)(t.issuer) || e.options.issuer,
        o = Object(b.z)(t.userinfoUrl) || e.options.userinfoUrl,
        i = Object(b.z)(t.tokenUrl) || e.options.tokenUrl,
        a = Object(b.z)(t.logoutUrl) || e.options.logoutUrl,
        s = Object(b.z)(t.revokeUrl) || e.options.revokeUrl,
        u = r.indexOf("/oauth2") > 0 ? r : r + "/oauth2";
      return {
        issuer: r,
        authorizeUrl: n = n || u + "/v1/authorize",
        userinfoUrl: o = o || u + "/v1/userinfo",
        tokenUrl: i = i || u + "/v1/token",
        revokeUrl: s = s || u + "/v1/revoke",
        logoutUrl: a = a || u + "/v1/logout"
      };
    }
    function Q(e) {
      return /(code=)/i.test(e);
    }
    function Z(e) {
      var t,
        n = e.options;
      if (n.pkce || "code" === n.responseType || "query" === n.responseMode) {
        var r = "fragment" === n.responseMode ? Q(window.location.hash) : Q(window.location.search);
        return function (e, t) {
          var n = t.options;
          return e && 0 == e.indexOf(n.redirectUri);
        }(window.location.href, e) && r;
      }
      return t = window.location.hash, /((id|access)_token=)/i.test(t);
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */
    var ee = n(20);
    /*!
     * Copyright (c) 2019-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
    function te(e) {
      return ("0" + e.toString(16)).substr(-2);
    }
    function ne(e, t) {
      return t = Object.assign({}, e.options.cookies, t), e.options.storageUtil.getPKCEStorage(t);
    }
    function re(e) {
      var t = ne(e);
      t.clearStorage(), (t = ne(e, {
        preferLocalStorage: !0
      })).clearStorage();
    }
    var oe = {
        DEFAULT_CODE_CHALLENGE_METHOD: "S256",
        generateVerifier: function generateVerifier(e) {
          var t,
            n,
            r = e || "";
          return r.length < 43 && (r += (t = 43 - r.length, n = new Uint8Array(Math.ceil(t / 2)), crypto.getRandomValues(n), Array.from(n, te).join("").slice(0, t))), encodeURIComponent(r).slice(0, 128);
        },
        clearMeta: re,
        saveMeta: function saveMeta(e, t) {
          var n = ne(e, {
              preferLocalStorage: !0
            }),
            r = n.getStorage();
          r.codeVerifier && Object(b.F)("saveMeta: PKCE codeVerifier exists in localStorage. This may indicate an auth flow is already in progress."), (r = (n = ne(e)).getStorage()).codeVerifier && Object(b.F)("saveMeta: PKCE codeVerifier exists in sessionStorage. This may indicate an auth flow is already in progress."), re(e), n.setStorage(t);
        },
        loadMeta: function loadMeta(e) {
          var t = ne(e, {
              preferLocalStorage: !0
            }),
            n = t.getStorage();
          if (!n.codeVerifier && !(n = (t = ne(e, {
            preferLocalStorage: !1
          })).getStorage()).codeVerifier) throw new m.a("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", null);
          return n;
        },
        computeChallenge: function computeChallenge(e) {
          var t = new TextEncoder().encode(e);
          return crypto.subtle.digest("SHA-256", t).then(function (e) {
            var t = String.fromCharCode.apply(null, new Uint8Array(e));
            return Object(b.A)(t);
          });
        },
        getToken: function getToken(e, t, n) {
          !function (e) {
            if (!e.clientId) throw new m.a("A clientId must be specified in the OktaAuth constructor to get a token");
            if (!e.redirectUri) throw new m.a("The redirectUri passed to /authorize must also be passed to /token");
            if (!e.authorizationCode) throw new m.a("An authorization code (returned from /authorize) must be passed to /token");
            if (!e.codeVerifier) throw new m.a('The "codeVerifier" (generated and saved by your app) must be passed to /token');
          }(t);
          var r = function (e) {
            var t = Object(b.y)({
              client_id: e.clientId,
              redirect_uri: e.redirectUri,
              grant_type: "authorization_code",
              code: e.authorizationCode,
              code_verifier: e.codeVerifier
            });
            return Object(b.D)(t).slice(1);
          }(t);
          return N.a.httpRequest(e, {
            url: n.tokenUrl,
            method: "POST",
            args: r,
            withCredentials: !1,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          });
        }
      },
      ie = n(9),
      ae = function ae(e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      se = D.a.storage;
    function ue(e, t) {
      return Promise.resolve().then(function () {
        var n, r;
        if (t && (n = t.accessToken, r = t.refreshToken), !n && !r) throw new m.a("A valid access or refresh token object is required");
        var o = e.options.clientId;
        if (!o) throw new m.a("A clientId must be specified in the OktaAuth constructor to revoke a token");
        var i = $(e).revokeUrl,
          a = Object(b.D)({
            token_type_hint: r ? "refresh_token" : "access_token",
            token: r || n
          }).slice(1),
          s = btoa(o);
        return N.a.post(e, i, a, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Basic " + s
          }
        });
      });
    }
    function ce(e) {
      var t,
        n = e.split(".");
      try {
        t = {
          header: JSON.parse(Object(b.d)(n[0])),
          payload: JSON.parse(Object(b.d)(n[1])),
          signature: n[2]
        };
      } catch (e) {
        throw new m.a("Malformed token");
      }
      return t;
    }
    function fe(e, t, n) {
      return Promise.resolve().then(function () {
        if (!t || !t.idToken) throw new m.a("Only idTokens may be verified");
        var r = ce(t.idToken),
          o = {
            clientId: e.options.clientId,
            issuer: e.options.issuer,
            ignoreSignature: e.options.ignoreSignature
          };
        return Object.assign(o, n), function (e, t, n) {
          var r = n.clientId,
            o = n.issuer,
            i = n.nonce;
          if (!t || !o || !r) throw new m.a("The jwt, iss, and aud arguments are all required");
          if (i && t.nonce !== i) throw new m.a("OAuth flow response nonce doesn't match request nonce");
          var a = Math.floor(Date.now() / 1e3);
          if (t.iss !== o) throw new m.a("The issuer [" + t.iss + "] does not match [" + o + "]");
          if (t.aud !== r) throw new m.a("The audience [" + t.aud + "] does not match [" + r + "]");
          if (t.iat > t.exp) throw new m.a("The JWT expired before it was issued");
          if (a - e.options.maxClockSkew > t.exp) throw new m.a("The JWT expired and is no longer valid");
          if (t.iat > a + e.options.maxClockSkew) throw new m.a("The JWT was issued in the future");
        }(e, r.payload, o), 1 != o.ignoreSignature && e.features.isTokenVerifySupported() ? function (e, t, n) {
          var r = D.a.getHttpCache(e.options.cookies);
          return X(e, t).then(function (t) {
            var o = t.jwks_uri,
              i = r.getStorage()[o];
            if (i && Date.now() / 1e3 < i.expiresAt) {
              var a = Object(b.k)(i.response.keys, {
                kid: n
              });
              if (a) return a;
            }
            return r.clearStorage(o), N.a.get(e, o, {
              cacheResponse: !0
            }).then(function (e) {
              var t = Object(b.k)(e.keys, {
                kid: n
              });
              if (t) return t;
              throw new m.a("The key id, " + n + ", was not found in the server's keys");
            });
          });
        }(e, t.issuer, r.header.kid).then(function (e) {
          return function (e, t) {
            t = Object(b.f)(t);
            var n = {
              name: "RSASSA-PKCS1-v1_5",
              hash: {
                name: "SHA-256"
              }
            };
            return delete t.use, crypto.subtle.importKey("jwk", t, n, !0, ["verify"]).then(function (t) {
              var r = e.split("."),
                o = Object(b.B)(r[0] + "." + r[1]),
                i = Object(b.b)(r[2]),
                a = Object(b.B)(i);
              return crypto.subtle.verify(n, t, a, o);
            });
          }(t.idToken, e);
        }).then(function (e) {
          if (!e) throw new m.a("The token signature is not valid");
          if (n && n.accessToken && t.claims.at_hash) return (r = n.accessToken, o = new TextEncoder().encode(r), crypto.subtle.digest("SHA-256", o).then(function (e) {
            var t = new Uint8Array(e).slice(0, 16),
              n = String.fromCharCode.apply(null, t);
            return Object(b.A)(n);
          })).then(function (e) {
            if (e !== t.claims.at_hash) throw new m.a("Token hash verification failed");
          });
          var r, o;
        }).then(function () {
          return t;
        }) : t;
      });
    }
    function le(e, t, n) {
      var r, o;
      return new Promise(function (i, a) {
        r = function r(t) {
          if (t.data && t.data.state === n) return t.origin !== e.getIssuerOrigin() ? a(new m.a("The request does not match client configuration")) : void i(t.data);
        }, G(window, "message", r), o = setTimeout(function () {
          a(new m.a("OAuth flow timed out"));
        }, t || 12e4);
      }).finally(function () {
        clearTimeout(o), V(window, "message", r);
      });
    }
    function de(e, t) {
      if (e.error || e.error_description) throw new ee.a(e.error, e.error_description);
      if (e.state !== t.state) throw new m.a("OAuth flow response state doesn't match request state");
    }
    function he(e, t, n, r) {
      r = r || {};
      var o = (t = t || {}).responseType;
      Array.isArray(o) || (o = [o]);
      var i = Object(b.f)(t.scopes),
        a = t.clientId || e.options.clientId,
        s = !1 !== e.options.pkce;
      return Promise.resolve().then(function () {
        return de(n, t), n.code && s ? (o = ["token"], -1 !== i.indexOf("openid") && o.push("id_token"), function (e, t, n, r) {
          var o = oe.loadMeta(e),
            i = {
              clientId: t.clientId,
              authorizationCode: n,
              codeVerifier: o.codeVerifier,
              redirectUri: o.redirectUri
            };
          return oe.getToken(e, i, r).then(function (e) {
            return de(e, i), e;
          }).finally(function () {
            oe.clearMeta(e);
          });
        }(e, t, n.code, r)) : n;
      }).then(function (n) {
        var o = {},
          s = n.expires_in,
          u = n.token_type,
          c = n.access_token,
          f = n.id_token,
          l = n.refresh_token;
        if (c) {
          var d = e.token.decode(c);
          o.accessToken = {
            value: c,
            accessToken: c,
            claims: d.payload,
            expiresAt: Number(s) + Math.floor(Date.now() / 1e3),
            tokenType: u,
            scopes: i,
            authorizeUrl: r.authorizeUrl,
            userinfoUrl: r.userinfoUrl
          };
        }
        if (l && (o.refreshToken = {
          value: l,
          refreshToken: l,
          expiresAt: Number(s) + Math.floor(Date.now() / 1e3),
          scopes: i,
          tokenUrl: r.tokenUrl,
          authorizeUrl: r.authorizeUrl,
          issuer: r.issuer
        }), f) {
          var h = e.token.decode(f),
            p = {
              value: f,
              idToken: f,
              claims: h.payload,
              expiresAt: h.payload.exp,
              scopes: i,
              authorizeUrl: r.authorizeUrl,
              issuer: r.issuer,
              clientId: a
            },
            g = {
              clientId: a,
              issuer: r.issuer,
              nonce: t.nonce,
              accessToken: c
            };
          return void 0 !== t.ignoreSignature && (g.ignoreSignature = t.ignoreSignature), fe(e, p, g).then(function () {
            return o.idToken = p, o;
          });
        }
        return o;
      }).then(function (e) {
        if (-1 !== o.indexOf("token") && !e.accessToken) throw new m.a('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
        if (-1 !== o.indexOf("id_token") && !e.idToken) throw new m.a('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
        return {
          tokens: e,
          state: n.state,
          code: n.code
        };
      });
    }
    function pe(e) {
      var t = function (e) {
        if (!e.clientId) throw new m.a("A clientId must be specified in the OktaAuth constructor to get a token");
        if (Object(b.v)(e.responseType) && -1 !== e.responseType.indexOf(" ")) throw new m.a("Multiple OAuth responseTypes must be defined as an array");
        var t = {
          client_id: e.clientId,
          code_challenge: e.codeChallenge,
          code_challenge_method: e.codeChallengeMethod,
          display: e.display,
          idp: e.idp,
          idp_scope: e.idpScope,
          login_hint: e.loginHint,
          max_age: e.maxAge,
          nonce: e.nonce,
          prompt: e.prompt,
          redirect_uri: e.redirectUri,
          response_mode: e.responseMode,
          response_type: e.responseType,
          sessionToken: e.sessionToken,
          state: e.state
        };
        if (t = Object(b.y)(t), ["idp_scope", "response_type"].forEach(function (e) {
          Array.isArray(t[e]) && (t[e] = t[e].join(" "));
        }), -1 !== e.responseType.indexOf("id_token") && -1 === e.scopes.indexOf("openid")) throw new m.a("openid scope must be specified in the scopes argument when requesting an id_token");
        return t.scope = e.scopes.join(" "), t;
      }(e);
      return Object(b.D)(t);
    }
    function ge(e, t) {
      return arguments.length > 2 ? Promise.reject(new m.a('As of version 3.0, "getToken" takes only a single set of options')) : me(e, t = t || {}).then(function (n) {
        var r, o;
        switch (t.sessionToken ? Object.assign(n, {
          prompt: "none",
          responseMode: "okta_post_message",
          display: null
        }) : t.idp && Object.assign(n, {
          display: "popup"
        }), o = $(e, n), r = (t.codeVerifier ? o.tokenUrl : o.authorizeUrl) + pe(n), n.sessionToken || null === n.display ? "IFRAME" : "popup" === n.display ? "POPUP" : "IMPLICIT") {
          case "IFRAME":
            var i = le(e, t.timeout, n.state),
              a = W(r);
            return i.then(function (t) {
              return he(e, n, t, o);
            }).finally(function () {
              document.body.contains(a) && a.parentElement.removeChild(a);
            });
          case "POPUP":
            var s;
            if ("okta_post_message" === n.responseMode) {
              if (!e.features.isPopupPostMessageSupported()) throw new m.a("This browser doesn't have full postMessage support");
              s = le(e, t.timeout, n.state);
            }
            var u = Y(r, {
              popupTitle: t.popupTitle
            });
            return new Promise(function (e, t) {
              var n = setInterval(function () {
                u && !u.closed || (clearInterval(n), t(new m.a("Unable to parse OAuth flow response")));
              }, 100);
              s.then(function (t) {
                clearInterval(n), e(t);
              }).catch(function (e) {
                clearInterval(n), t(e);
              });
            }).then(function (t) {
              return he(e, n, t, o);
            }).finally(function () {
              u && !u.closed && u.close();
            });
          default:
            throw new m.a("The full page redirect flow is not supported");
        }
      }).catch(function (t) {
        throw e.options.pkce && oe.clearMeta(e), t;
      });
    }
    function ve(e, t) {
      return arguments.length > 2 ? Promise.reject(new m.a('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = Object(b.f)(t) || {}, Object.assign(t, {
        prompt: "none",
        responseMode: "okta_post_message",
        display: null
      }), ge(e, t));
    }
    function ye(e, t) {
      return arguments.length > 2 ? Promise.reject(new m.a('As of version 3.0, "getWithPopup" takes only a single set of options')) : (t = Object(b.f)(t) || {}, Object.assign(t, {
        display: "popup",
        responseMode: "okta_post_message"
      }), ge(e, t));
    }
    function me(e, t) {
      if (Z(e)) return Promise.reject(new m.a("The app should not attempt to call getToken on callback. Authorize flow is already in process. Use parseFromUrl() to receive tokens."));
      t = Object(b.f)(t) || {};
      var n = function (e) {
        var t = e.options,
          n = t.pkce,
          r = t.clientId,
          o = t.redirectUri,
          i = t.responseType,
          a = t.responseMode,
          s = t.scopes,
          u = t.ignoreSignature;
        return {
          pkce: n,
          clientId: r,
          redirectUri: o || window.location.href,
          responseType: i || ["token", "id_token"],
          responseMode: a,
          state: Object(b.l)(64),
          nonce: Object(b.l)(64),
          scopes: s || ["openid", "email"],
          ignoreSignature: u
        };
      }(e);
      if (Object.assign(n, t), !1 === n.pkce) return Promise.resolve(n);
      if (!e.features.isPKCESupported()) {
        var r = "PKCE requires a modern browser with encryption support running in a secure context.";
        return e.features.isHTTPS() || (r += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e.features.hasTextEncoder() || (r += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), Promise.reject(new m.a(r));
      }
      return n.codeChallengeMethod || (n.codeChallengeMethod = oe.DEFAULT_CODE_CHALLENGE_METHOD), n.responseType = "code", X(e, null).then(function (e) {
        if (-1 === (e.code_challenge_methods_supported || []).indexOf(n.codeChallengeMethod)) throw new m.a("Invalid code_challenge_method");
      }).then(function () {
        var t = oe.generateVerifier(n.codeVerifier),
          r = {
            codeVerifier: t,
            redirectUri: n.redirectUri
          };
        return oe.saveMeta(e, r), oe.computeChallenge(t);
      }).then(function (e) {
        var t = Object(b.f)(n) || {};
        return Object.assign(t, n, {
          codeChallenge: e
        }), t;
      });
    }
    function be(e, t, n) {
      var r = t.responseType,
        o = t.state,
        i = t.nonce,
        a = t.scopes,
        s = t.clientId,
        u = t.ignoreSignature,
        c = JSON.stringify({
          responseType: r,
          state: o,
          nonce: i,
          scopes: a,
          clientId: s,
          urls: n,
          ignoreSignature: u
        });
      se.set(L.i, c, null, e.options.cookies), D.a.browserHasSessionStorage() && D.a.getSessionStorage().setItem(L.i, c);
    }
    function ke(e, t) {
      return arguments.length > 2 ? Promise.reject(new m.a('As of version 3.0, "getWithRedirect" takes only a single set of options')) : (t = Object(b.f)(t) || {}, me(e, t).then(function (n) {
        var r = $(e, t),
          o = r.authorizeUrl + pe(n);
        be(e, n, r), se.set(L.h, n.nonce, null, e.options.cookies), se.set(L.j, n.state, null, e.options.cookies), e.token.getWithRedirect._setLocation(o);
      }));
    }
    function we(e, t) {
      return Object(ie.isToken)(t) ? ve(e, {
        responseType: e.options.pkce ? "code" : Object(ie.isAccessToken)(t) ? "token" : "id_token",
        scopes: t.scopes,
        authorizeUrl: t.authorizeUrl,
        userinfoUrl: t.userinfoUrl,
        issuer: t.issuer
      }).then(function (e) {
        var n = e.tokens;
        return Object(ie.isIDToken)(t) ? n.idToken : n.accessToken;
      }) : Promise.reject(new m.a("Renew must be passed a token with an array of scopes and an accessToken or idToken"));
    }
    function Te(e, t) {
      return e.tokenManager.getTokens().then(function (e) {
        return e.refreshToken;
      }).then(function (n) {
        return n ? function (e, t, n) {
          return ae(this, void 0, void 0, i.a.mark(function r() {
            var o, a, s;
            return i.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    if (o = e.options.clientId) {
                      r.next = 3;
                      break;
                    }
                    throw new m.a("A clientId must be specified in the OktaAuth constructor to revoke a token");
                  case 3:
                    return a = $(e, t), r.prev = 4, r.next = 7, N.a.httpRequest(e, {
                      url: n.tokenUrl,
                      method: "POST",
                      withCredentials: !1,
                      headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                      },
                      args: Object.entries({
                        client_id: o,
                        grant_type: "refresh_token",
                        scope: n.scopes.join(" "),
                        refresh_token: n.refreshToken
                      }).map(function (e) {
                        var t = J()(e, 2),
                          n = t[0],
                          r = t[1];
                        return n + "=" + encodeURIComponent(r);
                      }).join("&")
                    });
                  case 7:
                    return s = r.sent, r.abrupt("return", he(e, t, s, a).then(function (e) {
                      return e.tokens;
                    }));
                  case 11:
                    r.prev = 11, r.t0 = r.catch(4), console.log({
                      err: r.t0
                    });
                  case 14:
                  case "end":
                    return r.stop();
                }
              }
            }, r, null, [[4, 11]]);
          }));
        }(e, t, n) : (t = Object.assign({
          scopes: e.options.scopes,
          authorizeUrl: e.options.authorizeUrl,
          userinfoUrl: e.options.userinfoUrl,
          issuer: e.options.issuer
        }, t), e.options.pkce ? t.responseType = "code" : t.responseType = ["token", "id_token"], ve(e, t).then(function (e) {
          return e.tokens;
        }));
      });
    }
    function Oe(e, t) {
      t = t || {}, t = Object(b.v)(t) ? {
        url: t
      } : t;
      var n,
        r = e.options.pkce ? "query" : "fragment",
        o = t.url,
        i = t.responseMode || e.options.responseMode || r,
        a = e.token.parseFromUrl._getLocation();
      if (!(n = "query" === i ? o ? o.substring(o.indexOf("?")) : a.search : o ? o.substring(o.indexOf("#")) : a.hash)) return Promise.reject(new m.a("Unable to parse a token from the url"));
      var s = function () {
        var e;
        return D.a.browserHasSessionStorage() && (e = D.a.getSessionStorage().getItem(L.i)), e || (e = se.get(L.i)), D.a.browserHasSessionStorage() && D.a.getSessionStorage().removeItem(L.i), se.delete(L.i), e;
      }();
      if (!s) return Promise.reject(new m.a("Unable to retrieve OAuth redirect params from storage"));
      try {
        var u = JSON.parse(s),
          c = u.urls;
        delete u.urls;
      } catch (e) {
        return Promise.reject(new m.a("Unable to parse the " + L.i + " value from storage: " + e.message));
      }
      return Promise.resolve(function (e) {
        var t = /\+/g,
          n = /([^&=]+)=?([^&]*)/g,
          r = e;
        "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
        for (var o, i = {}; o = n.exec(r);) {
          var a = o[1],
            s = o[2];
          i[a] = "id_token" === a || "access_token" === a || "code" === a ? s : decodeURIComponent(s.replace(t, " "));
        }
        return i;
      }(n)).then(function (t) {
        return o || ("query" === i ? function (e) {
          var t = e.token.parseFromUrl._getHistory(),
            n = e.token.parseFromUrl._getDocument(),
            r = e.token.parseFromUrl._getLocation();
          t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
        }(e) : function (e) {
          var t = e.token.parseFromUrl._getHistory(),
            n = e.token.parseFromUrl._getDocument(),
            r = e.token.parseFromUrl._getLocation();
          t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
        }(e)), he(e, u, t, c);
      });
    }
    function Se(e, t, n) {
      return ae(this, void 0, void 0, i.a.mark(function r() {
        return i.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (t) {
                  r.next = 4;
                  break;
                }
                return r.next = 3, e.tokenManager.getTokens();
              case 3:
                t = r.sent.accessToken;
              case 4:
                if (n) {
                  r.next = 8;
                  break;
                }
                return r.next = 7, e.tokenManager.getTokens();
              case 7:
                n = r.sent.idToken;
              case 8:
                if (t && Object(ie.isAccessToken)(t)) {
                  r.next = 10;
                  break;
                }
                return r.abrupt("return", Promise.reject(new m.a("getUserInfo requires an access token object")));
              case 10:
                if (n && Object(ie.isIDToken)(n)) {
                  r.next = 12;
                  break;
                }
                return r.abrupt("return", Promise.reject(new m.a("getUserInfo requires an ID token object")));
              case 12:
                return r.abrupt("return", N.a.httpRequest(e, {
                  url: t.userinfoUrl,
                  method: "GET",
                  accessToken: t.accessToken
                }).then(function (e) {
                  return e.sub === n.claims.sub ? e : Promise.reject(new m.a("getUserInfo request was rejected due to token mismatch"));
                }).catch(function (e) {
                  var t;
                  if (e.xhr && (401 === e.xhr.status || 403 === e.xhr.status) && (e.xhr.headers && Object(b.q)(e.xhr.headers.get) && e.xhr.headers.get("WWW-Authenticate") ? t = e.xhr.headers.get("WWW-Authenticate") : Object(b.q)(e.xhr.getResponseHeader) && (t = e.xhr.getResponseHeader("WWW-Authenticate")), t)) {
                    var n = t.match(/error="(.*?)"/) || [],
                      r = t.match(/error_description="(.*?)"/) || [],
                      o = n[1],
                      i = r[1];
                    o && i && (e = new ee.a(o, i));
                  }
                  throw e;
                }));
              case 13:
              case "end":
                return r.stop();
            }
          }
        }, r);
      }));
    }
    var _e = n(14),
      Ee = function () {
        function e() {
          s()(this, e), this.queue = [], this.running = !1;
        }
        return c()(e, [{
          key: "push",
          value: function value(e, t) {
            for (var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) {
              o[i - 2] = arguments[i];
            }
            return new Promise(function (r, i) {
              n.queue.push({
                method: e,
                thisObject: t,
                args: o,
                resolve: r,
                reject: i
              }), n.run();
            });
          }
        }, {
          key: "run",
          value: function value() {
            var e = this;
            if (!this.running && 0 !== this.queue.length) {
              this.running = !0;
              var t = this.queue.shift(),
                n = t.method.apply(t.thisObject, t.args);
              Object(b.u)(n) ? n.then(t.resolve, t.reject).finally(function () {
                e.running = !1, e.run();
              }) : (t.resolve(n), this.running = !1, this.run());
            }
          }
        }]), e;
      }(),
      Ae = n(17);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */
    function xe(e, t) {
      return t = t || {}, S() ? new Promise(function (i, a) {
        (r = document.createElement("iframe")).style.display = "none", o = function o(t) {
          if (t && t.data && t.origin === e.getIssuerOrigin()) {
            try {
              var n = JSON.parse(t.data);
            } catch (e) {
              return;
            }
            if (n) return "FingerprintAvailable" === n.type ? i(n.fingerprint) : void ("FingerprintServiceReady" === n.type && t.source.postMessage(JSON.stringify({
              type: "GetFingerprint"
            }), t.origin));
          }
        }, G(window, "message", o), r.src = e.getIssuerOrigin() + "/auth/services/devicefingerprint", document.body.appendChild(r), n = setTimeout(function () {
          a(new Ae.c("Fingerprinting timed out"));
        }, t.timeout || 15e3);
      }).finally(function () {
        clearTimeout(n), V(window, "message", o), document.body.contains(r) && r.parentElement.removeChild(r);
      }) : Promise.reject(new Ae.c("Fingerprinting is not supported on this device"));
      var n, r, o;
    }
    var je = n(49),
      Re = {
        isPending: !0,
        isAuthenticated: !1,
        idToken: null,
        accessToken: null,
        refreshToken: null
      },
      Pe = {
        updateAuthStatePromise: null,
        canceledTimes: 0
      },
      Ue = function () {
        function e(t) {
          var n = this;
          if (s()(this, e), !t.emitter) throw new Ae.c("Emitter should be initialized before AuthStateManager");
          this._sdk = t, this._pending = Object.assign({}, Pe), this._authState = Object.assign({}, Re), this._logOptions = {}, t.tokenManager.on(_e.a, function (e, t) {
            n._setLogOptions({
              event: _e.a,
              key: e,
              token: t
            }), n.updateAuthState();
          }), t.tokenManager.on(_e.d, function (e, t) {
            n._setLogOptions({
              event: _e.d,
              key: e,
              token: t
            }), n.updateAuthState();
          });
        }
        return c()(e, [{
          key: "_setLogOptions",
          value: function value(e) {
            this._logOptions = e;
          }
        }, {
          key: "getAuthState",
          value: function value() {
            return this._authState;
          }
        }, {
          key: "updateAuthState",
          value: function value() {
            var e = this;
            this._sdk.emitter.e && this._sdk.emitter.e.authStateChange && this._sdk.emitter.e.authStateChange.length || Object(b.F)("updateAuthState is an asynchronous method with no return, please subscribe to the latest authState update with authStateManager.subscribe(handler) method before calling updateAuthState.");
            var t = this._sdk.options,
              n = t.transformAuthState,
              r = t.devMode,
              o = this._sdk.tokenManager._getOptions(),
              i = o.autoRenew,
              a = o.autoRemove,
              s = function s(t) {
                var n = e._logOptions,
                  r = n.event,
                  o = n.key,
                  i = n.token;
                Object(b.m)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(r, " Status:").concat(t)), Object(b.m)().log(o, i), Object(b.m)().log("Current authState", e._authState), Object(b.m)().groupEnd(), e._logOptions = {};
              },
              u = function u(t) {
                var n, o;
                (n = e._authState, o = t, n.isPending !== o.isPending || n.isAuthenticated !== o.isAuthenticated || JSON.stringify(n.idToken) !== JSON.stringify(o.idToken) || JSON.stringify(n.accessToken) !== JSON.stringify(o.accessToken) || n.error !== o.error) ? (e._authState = t, e._sdk.emitter.emit("authStateChange", Object.assign({}, t)), r && s("emitted")) : r && s("unchanged");
              },
              c = function c() {
                return i || a;
              };
            if (this._pending.updateAuthStatePromise) {
              if (this._pending.canceledTimes >= 10) return void (r && s("terminated"));
              this._pending.updateAuthStatePromise.cancel();
            }
            var f = new je(function (t, o, i) {
              i.shouldReject = !1, i(function () {
                e._pending.updateAuthStatePromise = null, e._pending.canceledTimes = e._pending.canceledTimes + 1, r && s("canceled");
              });
              var a = function a(n) {
                f.isCanceled || (u(n), e._pending = Object.assign({}, Pe)), t();
              };
              e._sdk.tokenManager.getTokens().then(function (r) {
                var o = r.accessToken,
                  i = r.idToken,
                  s = r.refreshToken;
                if (f.isCanceled) t();else {
                  var u = !1;
                  o && e._sdk.tokenManager.hasExpired(o) && (o = null, u = c()), i && e._sdk.tokenManager.hasExpired(i) && (i = null, u = c());
                  var l = {
                    accessToken: o,
                    idToken: i,
                    refreshToken: s,
                    isPending: u,
                    isAuthenticated: !(!o || !i)
                  };
                  (n ? n(e._sdk, l) : Promise.resolve(l)).then(function (e) {
                    return a(e);
                  }).catch(function (e) {
                    return a({
                      accessToken: o,
                      idToken: i,
                      refreshToken: s,
                      isAuthenticated: !1,
                      isPending: !1,
                      error: e
                    });
                  });
                }
              });
            });
            this._pending.updateAuthStatePromise = f;
          }
        }, {
          key: "subscribe",
          value: function value(e) {
            this._sdk.emitter.on("authStateChange", e);
          }
        }, {
          key: "unsubscribe",
          value: function value(e) {
            this._sdk.emitter.off("authStateChange", e);
          }
        }]), e;
      }();
    function Ce(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */();
      return function () {
        var n,
          r = y()(e);
        if (t) {
          var o = y()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return g()(this, n);
      };
    }
    var Ie = function Ie(e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      Me = function Me(e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
        }
        return n;
      },
      De = n(50);
    function Le(e, t) {
      var n = t.cookies || {};
      return void 0 === n.secure && (n.secure = e.features.isHTTPS()), void 0 === n.sameSite && (n.sameSite = n.secure ? "none" : "lax"), n.secure && !e.features.isHTTPS() && (Object(b.F)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), n.secure = !1), "none" !== n.sameSite || n.secure || (n.sameSite = "lax"), n;
    }
    var Ne = function (e) {
      h()(n, e);
      var t = Ce(n);
      function n(e) {
        var r;
        s()(this, n), (r = t.call(this, Object.assign({
          httpRequestClient: M,
          storageUtil: D.a
        }, e)))._pending = {
          handleLogin: !1
        }, r.options = Object.assign(r.options, {
          clientId: e.clientId,
          authorizeUrl: Object(b.z)(e.authorizeUrl),
          userinfoUrl: Object(b.z)(e.userinfoUrl),
          tokenUrl: Object(b.z)(e.tokenUrl),
          revokeUrl: Object(b.z)(e.revokeUrl),
          logoutUrl: Object(b.z)(e.logoutUrl),
          pkce: !1 !== e.pkce,
          redirectUri: Object(b.C)(e.redirectUri, window.location.origin),
          postLogoutRedirectUri: e.postLogoutRedirectUri,
          responseMode: e.responseMode,
          responseType: e.responseType,
          transformErrorXHR: e.transformErrorXHR,
          cookies: Le(l()(r), e),
          scopes: e.scopes,
          transformAuthState: e.transformAuthState,
          restoreOriginalUri: e.restoreOriginalUri
        }), r.userAgent = function (e, t) {
          var n = e.userAgent || {};
          return n.value ? n.value : n.template ? n.template.replace("$OKTA_AUTH_JS", t) : t;
        }(e, "okta-auth-js/".concat("4.4.0")), e.maxClockSkew || 0 === e.maxClockSkew ? r.options.maxClockSkew = e.maxClockSkew : r.options.maxClockSkew = L.d, r.options.ignoreSignature = !!e.ignoreSignature, r.session = {
          close: K.bind(null, l()(r)),
          exists: F.bind(null, l()(r)),
          get: H.bind(null, l()(r)),
          refresh: B.bind(null, l()(r)),
          setCookieAndRedirect: q.bind(null, l()(r))
        }, r._tokenQueue = new Ee(), r.token = {
          getWithoutPrompt: ve.bind(null, l()(r)),
          getWithPopup: ye.bind(null, l()(r)),
          getWithRedirect: ke.bind(null, l()(r)),
          parseFromUrl: Oe.bind(null, l()(r)),
          decode: ce,
          revoke: ue.bind(null, l()(r)),
          renew: we.bind(null, l()(r)),
          renewTokens: Te.bind(null, l()(r)),
          getUserInfo: Se.bind(null, l()(r)),
          verify: fe.bind(null, l()(r)),
          isLoginRedirect: Z.bind(null, l()(r))
        };
        var o = ["decode", "isLoginRedirect"];
        return Object.keys(r.token).forEach(function (e) {
          if (!(o.indexOf(e) >= 0)) {
            var t = r.token[e];
            r.token[e] = Ee.prototype.push.bind(r._tokenQueue, t, null);
          }
        }), Object.assign(r.token.getWithRedirect, {
          _setLocation: function _setLocation(e) {
            window.location = e;
          }
        }), Object.assign(r.token.parseFromUrl, {
          _getHistory: function _getHistory() {
            return window.history;
          },
          _getLocation: function _getLocation() {
            return window.location;
          },
          _getDocument: function _getDocument() {
            return window.document;
          }
        }), r.fingerprint = xe.bind(null, l()(r)), r.emitter = new De(), r.tokenManager = new _e.f(l()(r), e.tokenManager), r.authStateManager = new Ue(l()(r)), r;
      }
      return c()(n, [{
        key: "signIn",
        value: function value(e) {
          return this.features.isLocalhost() && Object(b.h)("This method has been deprecated, please use signInWithCredentials() instead."), this.signInWithCredentials(e);
        }
      }, {
        key: "signInWithCredentials",
        value: function value(e) {
          var t = this;
          e = Object(b.f)(e || {});
          var n = function n(_n) {
            return delete e.sendFingerprint, Object(k.g)(t, "/api/v1/authn", e, _n);
          };
          return e.sendFingerprint ? this.fingerprint().then(function (e) {
            return n({
              headers: {
                "X-Device-Fingerprint": e
              }
            });
          }) : n();
        }
      }, {
        key: "signInWithRedirect",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.originalUri,
            n = Me(e, ["originalUri"]);
          return Ie(this, void 0, void 0, i.a.mark(function e() {
            var r;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!this._pending.handleLogin) {
                      e.next = 2;
                      break;
                    }
                    return e.abrupt("return");
                  case 2:
                    return this._pending.handleLogin = !0, e.prev = 3, t && this.setOriginalUri(t), r = Object.assign({
                      scopes: this.options.scopes || ["openid", "email", "profile"]
                    }, n), e.next = 8, this.token.getWithRedirect(r);
                  case 8:
                    return e.prev = 8, this._pending.handleLogin = !1, e.finish(8);
                  case 11:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[3,, 8, 11]]);
          }));
        }
      }, {
        key: "closeSession",
        value: function value() {
          return this.tokenManager.clear(), this.session.close().catch(function (e) {
            if ("AuthApiError" !== e.name || "E0000007" !== e.errorCode) throw e;
          });
        }
      }, {
        key: "revokeAccessToken",
        value: function value(e) {
          return Ie(this, void 0, void 0, i.a.mark(function t() {
            var n;
            return i.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (e) {
                      t.next = 6;
                      break;
                    }
                    return t.next = 3, this.tokenManager.getTokens();
                  case 3:
                    e = t.sent.accessToken, n = this.tokenManager._getStorageKeyByType("accessToken"), this.tokenManager.remove(n);
                  case 6:
                    if (e) {
                      t.next = 8;
                      break;
                    }
                    return t.abrupt("return", Promise.resolve());
                  case 8:
                    return t.abrupt("return", this.token.revoke(e));
                  case 9:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "revokeRefreshToken",
        value: function value(e) {
          return Ie(this, void 0, void 0, i.a.mark(function t() {
            var n;
            return i.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (e) {
                      t.next = 6;
                      break;
                    }
                    return t.next = 3, this.tokenManager.getTokens();
                  case 3:
                    e = t.sent.refreshToken, n = this.tokenManager._getStorageKeyByType("refreshToken"), this.tokenManager.remove(n);
                  case 6:
                    if (e) {
                      t.next = 8;
                      break;
                    }
                    return t.abrupt("return", Promise.resolve());
                  case 8:
                    return t.abrupt("return", this.token.revoke(e));
                  case 9:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "signOut",
        value: function value(e) {
          return Ie(this, void 0, void 0, i.a.mark(function t() {
            var n, r, o, a, s, u, c, f, l, d, h;
            return i.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (e = Object.assign({}, e), n = window.location.origin, r = window.location.href, o = e.postLogoutRedirectUri || this.options.postLogoutRedirectUri || n, a = e.accessToken, s = e.refreshToken, u = !1 !== e.revokeAccessToken, c = e.idToken, f = $(this).logoutUrl, void 0 !== c) {
                      t.next = 13;
                      break;
                    }
                    return t.next = 12, this.tokenManager.getTokens();
                  case 12:
                    c = t.sent.idToken;
                  case 13:
                    if (!u || void 0 !== s) {
                      t.next = 17;
                      break;
                    }
                    return t.next = 16, this.tokenManager.getTokens();
                  case 16:
                    s = t.sent.refreshToken;
                  case 17:
                    if (!u || void 0 !== a) {
                      t.next = 21;
                      break;
                    }
                    return t.next = 20, this.tokenManager.getTokens();
                  case 20:
                    a = t.sent.accessToken;
                  case 21:
                    if (this.tokenManager.clear(), !u || !s) {
                      t.next = 25;
                      break;
                    }
                    return t.next = 25, this.revokeRefreshToken(s);
                  case 25:
                    if (!u || !a) {
                      t.next = 28;
                      break;
                    }
                    return t.next = 28, this.revokeAccessToken(a);
                  case 28:
                    if (c) {
                      t.next = 30;
                      break;
                    }
                    return t.abrupt("return", this.closeSession().then(function () {
                      o === r ? window.location.reload() : window.location.assign(o);
                    }));
                  case 30:
                    l = e.state, d = c.idToken, h = f + "?id_token_hint=" + encodeURIComponent(d) + "&post_logout_redirect_uri=" + encodeURIComponent(o), l && (h += "&state=" + encodeURIComponent(l)), window.location.assign(h);
                  case 35:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "webfinger",
        value: function value(e) {
          var t = "/.well-known/webfinger" + Object(b.D)(e);
          return N.a.get(this, t, {
            headers: {
              Accept: "application/jrd+json"
            }
          });
        }
      }, {
        key: "isAuthenticated",
        value: function value(e) {
          return Ie(this, void 0, void 0, i.a.mark(function t() {
            var n,
              r,
              o,
              a,
              s = this;
            return i.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if ((n = this.authStateManager.getAuthState()).isPending) {
                      t.next = 3;
                      break;
                    }
                    return t.abrupt("return", Promise.resolve(n.isAuthenticated));
                  case 3:
                    return t.abrupt("return", new Promise(function (t) {
                      r = function r() {
                        s.authStateManager.unsubscribe(o), clearTimeout(a);
                      }, o = function o(e) {
                        var n = e.isAuthenticated;
                        e.isPending || (t(n), r());
                      }, a = setTimeout(function () {
                        t(!1), r();
                      }, e || 6e4), s.authStateManager.subscribe(o), s.authStateManager.updateAuthState();
                    }));
                  case 4:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "getUser",
        value: function value() {
          return Ie(this, void 0, void 0, i.a.mark(function e() {
            var t, n, r;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return t = this.authStateManager.getAuthState(), n = t.idToken, r = t.accessToken, e.abrupt("return", this.token.getUserInfo(r, n));
                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "getIdToken",
        value: function value() {
          var e = this.authStateManager.getAuthState().idToken;
          return e ? e.idToken : void 0;
        }
      }, {
        key: "getAccessToken",
        value: function value() {
          var e = this.authStateManager.getAuthState().accessToken;
          return e ? e.accessToken : void 0;
        }
      }, {
        key: "getRefreshToken",
        value: function value() {
          var e = this.authStateManager.getAuthState().refreshToken;
          return e ? e.refreshToken : void 0;
        }
      }, {
        key: "storeTokensFromRedirect",
        value: function value() {
          return Ie(this, void 0, void 0, i.a.mark(function e() {
            var t, n;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.token.parseFromUrl();
                  case 2:
                    t = e.sent, n = t.tokens, this.tokenManager.setTokens(n);
                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "setOriginalUri",
        value: function value(e) {
          e = e || window.location.href, D.a.getSessionStorage().setItem(L.k, e);
        }
      }, {
        key: "getOriginalUri",
        value: function value() {
          return D.a.getSessionStorage().getItem(L.k) || window.location.origin;
        }
      }, {
        key: "removeOriginalUri",
        value: function value() {
          D.a.getSessionStorage().removeItem(L.k);
        }
      }, {
        key: "isLoginRedirect",
        value: function value() {
          return Z(this);
        }
      }, {
        key: "handleLoginRedirect",
        value: function value(e) {
          return Ie(this, void 0, void 0, i.a.mark(function t() {
            var n,
              r = this;
            return i.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (n = function e(t) {
                      var n = t.isPending;
                      return Ie(r, void 0, void 0, i.a.mark(function t() {
                        var r, o;
                        return i.a.wrap(function (t) {
                          for (;;) {
                            switch (t.prev = t.next) {
                              case 0:
                                if (!n) {
                                  t.next = 2;
                                  break;
                                }
                                return t.abrupt("return");
                              case 2:
                                if (this.authStateManager.unsubscribe(e), r = this.getOriginalUri(), this.removeOriginalUri(), !(o = this.options.restoreOriginalUri)) {
                                  t.next = 11;
                                  break;
                                }
                                return t.next = 9, o(this, r);
                              case 9:
                                t.next = 12;
                                break;
                              case 11:
                                window.location.replace(r);
                              case 12:
                              case "end":
                                return t.stop();
                            }
                          }
                        }, t, this);
                      }));
                    }, this.authStateManager.subscribe(n), !e) {
                      t.next = 6;
                      break;
                    }
                    this.tokenManager.setTokens(e), t.next = 12;
                    break;
                  case 6:
                    if (!this.isLoginRedirect()) {
                      t.next = 11;
                      break;
                    }
                    return t.next = 9, this.storeTokensFromRedirect();
                  case 9:
                    t.next = 12;
                    break;
                  case 11:
                    this.authStateManager.unsubscribe(n);
                  case 12:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "isPKCE",
        value: function value() {
          return !!this.options.pkce;
        }
      }, {
        key: "hasResponseType",
        value: function value(e) {
          var t = !1;
          return t = Array.isArray(this.options.responseType) && this.options.responseType.length ? this.options.responseType.indexOf(e) >= 0 : this.options.responseType === e, t;
        }
      }, {
        key: "isAuthorizationCodeFlow",
        value: function value() {
          return this.hasResponseType("code");
        }
      }]), n;
    }(w);
    Ne.features = Ne.prototype.features = r;
    t.a = Ne;
  }, function (e, t) {
    var n = function (e) {
      function t() {
        this.fetch = !1, this.DOMException = e.DOMException;
      }
      return t.prototype = e, new t();
    }("undefined" != typeof self ? self : this);
    !function (e) {
      !function (t) {
        var n = ("URLSearchParams" in e),
          r = "Symbol" in e && "iterator" in Symbol,
          o = "FileReader" in e && "Blob" in e && function () {
            try {
              return new Blob(), !0;
            } catch (e) {
              return !1;
            }
          }(),
          i = ("FormData" in e),
          a = ("ArrayBuffer" in e);
        if (a) var s = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          u = ArrayBuffer.isView || function (e) {
            return e && s.indexOf(Object.prototype.toString.call(e)) > -1;
          };
        function c(e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
          return e.toLowerCase();
        }
        function f(e) {
          return "string" != typeof e && (e = String(e)), e;
        }
        function l(e) {
          var t = {
            next: function next() {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return r && (t[Symbol.iterator] = function () {
            return t;
          }), t;
        }
        function d(e) {
          this.map = {}, e instanceof d ? e.forEach(function (e, t) {
            this.append(t, e);
          }, this) : Array.isArray(e) ? e.forEach(function (e) {
            this.append(e[0], e[1]);
          }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
            this.append(t, e[t]);
          }, this);
        }
        function h(e) {
          if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
          e.bodyUsed = !0;
        }
        function p(e) {
          return new Promise(function (t, n) {
            e.onload = function () {
              t(e.result);
            }, e.onerror = function () {
              n(e.error);
            };
          });
        }
        function g(e) {
          var t = new FileReader(),
            n = p(t);
          return t.readAsArrayBuffer(e), n;
        }
        function v(e) {
          if (e.slice) return e.slice(0);
          var t = new Uint8Array(e.byteLength);
          return t.set(new Uint8Array(e)), t.buffer;
        }
        function y() {
          return this.bodyUsed = !1, this._initBody = function (e) {
            var t;
            this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : o && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : i && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : a && o && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = v(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a && (ArrayBuffer.prototype.isPrototypeOf(e) || u(e)) ? this._bodyArrayBuffer = v(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, o && (this.blob = function () {
            var e = h(this);
            if (e) return e;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(g);
          }), this.text = function () {
            var e,
              t,
              n,
              r = h(this);
            if (r) return r;
            if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), n = p(t), t.readAsText(e), n;
            if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
              for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) {
                n[r] = String.fromCharCode(t[r]);
              }
              return n.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, i && (this.formData = function () {
            return this.text().then(k);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }
        d.prototype.append = function (e, t) {
          e = c(e), t = f(t);
          var n = this.map[e];
          this.map[e] = n ? n + ", " + t : t;
        }, d.prototype.delete = function (e) {
          delete this.map[c(e)];
        }, d.prototype.get = function (e) {
          return e = c(e), this.has(e) ? this.map[e] : null;
        }, d.prototype.has = function (e) {
          return this.map.hasOwnProperty(c(e));
        }, d.prototype.set = function (e, t) {
          this.map[c(e)] = f(t);
        }, d.prototype.forEach = function (e, t) {
          for (var n in this.map) {
            this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
          }
        }, d.prototype.keys = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push(n);
          }), l(e);
        }, d.prototype.values = function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), l(e);
        }, d.prototype.entries = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push([n, t]);
          }), l(e);
        }, r && (d.prototype[Symbol.iterator] = d.prototype.entries);
        var m = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function b(e, t) {
          var n,
            r,
            o = (t = t || {}).body;
          if (e instanceof b) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new d(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
          } else this.url = String(e);
          if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new d(t.headers)), this.method = (n = t.method || this.method || "GET", r = n.toUpperCase(), m.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
          this._initBody(o);
        }
        function k(e) {
          var t = new FormData();
          return e.trim().split("&").forEach(function (e) {
            if (e) {
              var n = e.split("="),
                r = n.shift().replace(/\+/g, " "),
                o = n.join("=").replace(/\+/g, " ");
              t.append(decodeURIComponent(r), decodeURIComponent(o));
            }
          }), t;
        }
        function w(e, t) {
          t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new d(t.headers), this.url = t.url || "", this._initBody(e);
        }
        b.prototype.clone = function () {
          return new b(this, {
            body: this._bodyInit
          });
        }, y.call(b.prototype), y.call(w.prototype), w.prototype.clone = function () {
          return new w(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new d(this.headers),
            url: this.url
          });
        }, w.error = function () {
          var e = new w(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var T = [301, 302, 303, 307, 308];
        w.redirect = function (e, t) {
          if (-1 === T.indexOf(t)) throw new RangeError("Invalid status code");
          return new w(null, {
            status: t,
            headers: {
              location: e
            }
          });
        }, t.DOMException = e.DOMException;
        try {
          new t.DOMException();
        } catch (e) {
          t.DOMException = function (e, t) {
            this.message = e, this.name = t;
            var n = Error(e);
            this.stack = n.stack;
          }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
        }
        function O(e, n) {
          return new Promise(function (r, i) {
            var a = new b(e, n);
            if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
            var s = new XMLHttpRequest();
            function u() {
              s.abort();
            }
            s.onload = function () {
              var e,
                t,
                n = {
                  status: s.status,
                  statusText: s.statusText,
                  headers: (e = s.getAllResponseHeaders() || "", t = new d(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                    var n = e.split(":"),
                      r = n.shift().trim();
                    if (r) {
                      var o = n.join(":").trim();
                      t.append(r, o);
                    }
                  }), t)
                };
              n.url = "responseURL" in s ? s.responseURL : n.headers.get("X-Request-URL");
              var o = "response" in s ? s.response : s.responseText;
              r(new w(o, n));
            }, s.onerror = function () {
              i(new TypeError("Network request failed"));
            }, s.ontimeout = function () {
              i(new TypeError("Network request failed"));
            }, s.onabort = function () {
              i(new t.DOMException("Aborted", "AbortError"));
            }, s.open(a.method, a.url, !0), "include" === a.credentials ? s.withCredentials = !0 : "omit" === a.credentials && (s.withCredentials = !1), "responseType" in s && o && (s.responseType = "blob"), a.headers.forEach(function (e, t) {
              s.setRequestHeader(t, e);
            }), a.signal && (a.signal.addEventListener("abort", u), s.onreadystatechange = function () {
              4 === s.readyState && a.signal.removeEventListener("abort", u);
            }), s.send(void 0 === a._bodyInit ? null : a._bodyInit);
          });
        }
        O.polyfill = !0, e.fetch || (e.fetch = O, e.Headers = d, e.Request = b, e.Response = w), t.Headers = d, t.Request = b, t.Response = w, t.fetch = O;
      }({});
    }(n), delete n.fetch.polyfill, (t = n.fetch).default = n.fetch, t.fetch = n.fetch, t.Headers = n.Headers, t.Request = n.Request, t.Response = n.Response, e.exports = t;
  }, function (e, t, n) {
    var r = n(44),
      o = n(45),
      i = n(46),
      a = n(48);
    e.exports = function (e, t) {
      return r(e) || o(e, t) || i(e, t) || a();
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(35);
    n.d(t, "OktaAuth", function () {
      return r.a;
    });
    var o = n(2);
    n.d(t, "STATE_TOKEN_KEY_NAME", function () {
      return o.m;
    }), n.d(t, "DEFAULT_POLLING_DELAY", function () {
      return o.e;
    }), n.d(t, "DEFAULT_MAX_CLOCK_SKEW", function () {
      return o.d;
    }), n.d(t, "DEFAULT_CACHE_DURATION", function () {
      return o.c;
    }), n.d(t, "REDIRECT_OAUTH_PARAMS_NAME", function () {
      return o.i;
    }), n.d(t, "REDIRECT_STATE_COOKIE_NAME", function () {
      return o.j;
    }), n.d(t, "REDIRECT_NONCE_COOKIE_NAME", function () {
      return o.h;
    }), n.d(t, "TOKEN_STORAGE_NAME", function () {
      return o.n;
    }), n.d(t, "CACHE_STORAGE_NAME", function () {
      return o.b;
    }), n.d(t, "PKCE_STORAGE_NAME", function () {
      return o.g;
    }), n.d(t, "ACCESS_TOKEN_STORAGE_KEY", function () {
      return o.a;
    }), n.d(t, "ID_TOKEN_STORAGE_KEY", function () {
      return o.f;
    }), n.d(t, "REFRESH_TOKEN_STORAGE_KEY", function () {
      return o.l;
    }), n.d(t, "REFERRER_PATH_STORAGE_KEY", function () {
      return o.k;
    });
    var i = n(9);
    for (var a in i) {
      ["OktaAuth", "STATE_TOKEN_KEY_NAME", "DEFAULT_POLLING_DELAY", "DEFAULT_MAX_CLOCK_SKEW", "DEFAULT_CACHE_DURATION", "REDIRECT_OAUTH_PARAMS_NAME", "REDIRECT_STATE_COOKIE_NAME", "REDIRECT_NONCE_COOKIE_NAME", "TOKEN_STORAGE_NAME", "CACHE_STORAGE_NAME", "PKCE_STORAGE_NAME", "ACCESS_TOKEN_STORAGE_KEY", "ID_TOKEN_STORAGE_KEY", "REFRESH_TOKEN_STORAGE_KEY", "REFERRER_PATH_STORAGE_KEY", "default"].indexOf(a) < 0 && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }
    var s = n(12);
    n.d(t, "transactionStatus", function () {
      return s.j;
    }), n.d(t, "resumeTransaction", function () {
      return s.h;
    }), n.d(t, "transactionExists", function () {
      return s.i;
    }), n.d(t, "postToTransaction", function () {
      return s.g;
    }), n.d(t, "introspect", function () {
      return s.f;
    }), n.d(t, "AuthTransaction", function () {
      return s.a;
    }), n.d(t, "getPollFn", function () {
      return s.d;
    }), n.d(t, "TransactionState", function () {
      return s.b;
    }), n.d(t, "addStateToken", function () {
      return s.c;
    }), n.d(t, "getStateToken", function () {
      return s.e;
    });
    var u = n(17);
    n.d(t, "AuthApiError", function () {
      return u.a;
    }), n.d(t, "AuthPollStopError", function () {
      return u.b;
    }), n.d(t, "AuthSdkError", function () {
      return u.c;
    }), n.d(t, "OAuthError", function () {
      return u.d;
    });
    var c = n(14);
    n.d(t, "EVENT_EXPIRED", function () {
      return c.c;
    }), n.d(t, "EVENT_RENEWED", function () {
      return c.e;
    }), n.d(t, "EVENT_ADDED", function () {
      return c.a;
    }), n.d(t, "EVENT_REMOVED", function () {
      return c.d;
    }), n.d(t, "EVENT_ERROR", function () {
      return c.b;
    }), n.d(t, "TokenManager", function () {
      return c.f;
    });
    var f = n(0);
    n.d(t, "stringToBase64Url", function () {
      return f.A;
    }), n.d(t, "base64ToBase64Url", function () {
      return f.a;
    }), n.d(t, "base64UrlToBase64", function () {
      return f.c;
    }), n.d(t, "base64UrlToString", function () {
      return f.d;
    }), n.d(t, "stringToBuffer", function () {
      return f.B;
    }), n.d(t, "base64UrlDecode", function () {
      return f.b;
    }), n.d(t, "bind", function () {
      return f.e;
    }), n.d(t, "isAbsoluteUrl", function () {
      return f.p;
    }), n.d(t, "toAbsoluteUrl", function () {
      return f.C;
    }), n.d(t, "toRelativeUrl", function () {
      return f.E;
    }), n.d(t, "isString", function () {
      return f.v;
    }), n.d(t, "isObject", function () {
      return f.t;
    }), n.d(t, "isNumber", function () {
      return f.s;
    }), n.d(t, "isoToUTCString", function () {
      return f.w;
    }), n.d(t, "toQueryString", function () {
      return f.D;
    }), n.d(t, "genRandomString", function () {
      return f.l;
    }), n.d(t, "extend", function () {
      return f.j;
    }), n.d(t, "removeNils", function () {
      return f.y;
    }), n.d(t, "clone", function () {
      return f.f;
    }), n.d(t, "omit", function () {
      return f.x;
    }), n.d(t, "find", function () {
      return f.k;
    }), n.d(t, "getLink", function () {
      return f.n;
    }), n.d(t, "getNativeConsole", function () {
      return f.o;
    }), n.d(t, "getConsole", function () {
      return f.m;
    }), n.d(t, "warn", function () {
      return f.F;
    }), n.d(t, "deprecate", function () {
      return f.h;
    }), n.d(t, "deprecateWrap", function () {
      return f.i;
    }), n.d(t, "removeTrailingSlash", function () {
      return f.z;
    }), n.d(t, "isIE11OrLess", function () {
      return f.r;
    }), n.d(t, "isFunction", function () {
      return f.q;
    }), n.d(t, "delay", function () {
      return f.g;
    }), n.d(t, "isPromise", function () {
      return f.u;
    });
  }, function (e, t, n) {
    var r = function (e) {
      "use strict";

      var t = Object.prototype,
        n = t.hasOwnProperty,
        r = "function" == typeof Symbol ? Symbol : {},
        o = r.iterator || "@@iterator",
        i = r.asyncIterator || "@@asyncIterator",
        a = r.toStringTag || "@@toStringTag";
      function s(e, t, n, r) {
        var o = t && t.prototype instanceof f ? t : f,
          i = Object.create(o.prototype),
          a = new T(r || []);
        return i._invoke = function (e, t, n) {
          var r = "suspendedStart";
          return function (o, i) {
            if ("executing" === r) throw new Error("Generator is already running");
            if ("completed" === r) {
              if ("throw" === o) throw i;
              return S();
            }
            for (n.method = o, n.arg = i;;) {
              var a = n.delegate;
              if (a) {
                var s = b(a, n);
                if (s) {
                  if (s === c) continue;
                  return s;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if ("suspendedStart" === r) throw r = "completed", n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = "executing";
              var f = u(e, t, n);
              if ("normal" === f.type) {
                if (r = n.done ? "completed" : "suspendedYield", f.arg === c) continue;
                return {
                  value: f.arg,
                  done: n.done
                };
              }
              "throw" === f.type && (r = "completed", n.method = "throw", n.arg = f.arg);
            }
          };
        }(e, n, a), i;
      }
      function u(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = s;
      var c = {};
      function f() {}
      function l() {}
      function d() {}
      var h = {};
      h[o] = function () {
        return this;
      };
      var p = Object.getPrototypeOf,
        g = p && p(p(O([])));
      g && g !== t && n.call(g, o) && (h = g);
      var v = d.prototype = f.prototype = Object.create(h);
      function y(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }
      function m(e, t) {
        var r;
        this._invoke = function (o, i) {
          function a() {
            return new t(function (r, a) {
              !function r(o, i, a, s) {
                var c = u(e[o], e, i);
                if ("throw" !== c.type) {
                  var f = c.arg,
                    l = f.value;
                  return l && "object" == typeof l && n.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    r("next", e, a, s);
                  }, function (e) {
                    r("throw", e, a, s);
                  }) : t.resolve(l).then(function (e) {
                    f.value = e, a(f);
                  }, function (e) {
                    return r("throw", e, a, s);
                  });
                }
                s(c.arg);
              }(o, i, r, a);
            });
          }
          return r = r ? r.then(a, a) : a();
        };
      }
      function b(e, t) {
        var n = e.iterator[t.method];
        if (void 0 === n) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = void 0, b(e, t), "throw" === t.method)) return c;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return c;
        }
        var r = u(n, e.iterator, t.arg);
        if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, c;
        var o = r.arg;
        return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, c) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, c);
      }
      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function w(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }
      function O(e) {
        if (e) {
          var t = e[o];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var r = -1,
              i = function t() {
                for (; ++r < e.length;) {
                  if (n.call(e, r)) return t.value = e[r], t.done = !1, t;
                }
                return t.value = void 0, t.done = !0, t;
              };
            return i.next = i;
          }
        }
        return {
          next: S
        };
      }
      function S() {
        return {
          value: void 0,
          done: !0
        };
      }
      return l.prototype = v.constructor = d, d.constructor = l, d[a] = l.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === l || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, d) : (e.__proto__ = d, a in e || (e[a] = "GeneratorFunction")), e.prototype = Object.create(v), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, y(m.prototype), m.prototype[i] = function () {
        return this;
      }, e.AsyncIterator = m, e.async = function (t, n, r, o, i) {
        void 0 === i && (i = Promise);
        var a = new m(s(t, n, r, o), i);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, y(v), v[a] = "Generator", v[o] = function () {
        return this;
      }, v.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];
        for (var n in e) {
          t.push(n);
        }
        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }
          return n.done = !0, n;
        };
      }, e.values = O, T.prototype = {
        constructor: T,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(w), !e) for (var t in this) {
            "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;
          function r(n, r) {
            return a.type = "throw", a.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
              a = i.completion;
            if ("root" === i.tryLoc) return r("end");
            if (i.tryLoc <= this.prev) {
              var s = n.call(i, "catchLoc"),
                u = n.call(i, "finallyLoc");
              if (s && u) {
                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
              } else if (s) {
                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, c) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), c;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), w(n), c;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                w(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: O(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = void 0), c;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = r;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t) {
    e.exports = function (e) {
      return -1 !== Function.toString.call(e).indexOf("[native code]");
    };
  }, function (e, t, n) {
    var r = n(23),
      o = n(42);
    function i(t, n, a) {
      return o() ? e.exports = i = Reflect.construct : e.exports = i = function i(e, t, n) {
        var o = [null];
        o.push.apply(o, t);
        var i = new (Function.bind.apply(e, o))();
        return n && r(i, n.prototype), i;
      }, i.apply(null, arguments);
    }
    e.exports = i;
  }, function (e, t) {
    e.exports = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    };
  }, function (e, t, n) {
    var r, o;
    /*!
     * JavaScript Cookie v2.2.0
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */
    !function (i) {
      if (void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o), !0, e.exports = i(), !!0) {
        var a = window.Cookies,
          s = window.Cookies = i();
        s.noConflict = function () {
          return window.Cookies = a, s;
        };
      }
    }(function () {
      function e() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) {
            t[r] = n[r];
          }
        }
        return t;
      }
      return function t(n) {
        function r(t, o, i) {
          var a;
          if ("undefined" != typeof document) {
            if (arguments.length > 1) {
              if ("number" == typeof (i = e({
                path: "/"
              }, r.defaults, i)).expires) {
                var s = new Date();
                s.setMilliseconds(s.getMilliseconds() + 864e5 * i.expires), i.expires = s;
              }
              i.expires = i.expires ? i.expires.toUTCString() : "";
              try {
                a = JSON.stringify(o), /^[\{\[]/.test(a) && (o = a);
              } catch (e) {}
              o = n.write ? n.write(o, t) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = (t = (t = encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
              var u = "";
              for (var c in i) {
                i[c] && (u += "; " + c, !0 !== i[c] && (u += "=" + i[c]));
              }
              return document.cookie = t + "=" + o + u;
            }
            t || (a = {});
            for (var f = document.cookie ? document.cookie.split("; ") : [], l = /(%[0-9A-Z]{2})+/g, d = 0; d < f.length; d++) {
              var h = f[d].split("="),
                p = h.slice(1).join("=");
              this.json || '"' !== p.charAt(0) || (p = p.slice(1, -1));
              try {
                var g = h[0].replace(l, decodeURIComponent);
                if (p = n.read ? n.read(p, g) : n(p, g) || p.replace(l, decodeURIComponent), this.json) try {
                  p = JSON.parse(p);
                } catch (e) {}
                if (t === g) {
                  a = p;
                  break;
                }
                t || (a[g] = p);
              } catch (e) {}
            }
            return a;
          }
        }
        return r.set = r, r.get = function (e) {
          return r.call(r, e);
        }, r.getJSON = function () {
          return r.apply({
            json: !0
          }, [].slice.call(arguments));
        }, r.defaults = {}, r.remove = function (t, n) {
          r(t, "", e(n, {
            expires: -1
          }));
        }, r.withConverter = t, r;
      }(function () {});
    });
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var n = [],
          r = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (o) throw i;
          }
        }
        return n;
      }
    };
  }, function (e, t, n) {
    var r = n(47);
    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return r(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
      }
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }
      return r;
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(3),
      o = n(13),
      i = n(10),
      a = n(11),
      s = n(8);
    function u(e, t) {
      var _n2;
      if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
        if (Array.isArray(e) || (_n2 = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return c(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          _n2 && (e = _n2);
          var r = 0,
            o = function o() {};
          return {
            s: o,
            n: function n() {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            },
            e: function e(_e2) {
              throw _e2;
            },
            f: o
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var i,
        a = !0,
        s = !1;
      return {
        s: function s() {
          _n2 = e[Symbol.iterator]();
        },
        n: function n() {
          var e = _n2.next();
          return a = e.done, e;
        },
        e: function e(_e3) {
          s = !0, i = _e3;
        },
        f: function f() {
          try {
            a || null == _n2.return || _n2.return();
          } finally {
            if (s) throw i;
          }
        }
      };
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }
      return r;
    }
    function f(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = s(e);
        if (t) {
          var o = s(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return a(this, n);
      };
    }
    var l = function (e) {
        i(n, e);
        var t = f(n);
        function n(e) {
          var o;
          return r(this, n), (o = t.call(this, e || "Promise was canceled")).name = "CancelError", o;
        }
        return o(n, [{
          key: "isCanceled",
          get: function get() {
            return !0;
          }
        }]), n;
      }(n(24)(Error)),
      d = function () {
        function e(t) {
          var n = this;
          r(this, e), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function (e, r) {
            n._reject = r;
            var o = function o(e) {
              if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
              n._cancelHandlers.push(e);
            };
            return Object.defineProperties(o, {
              shouldReject: {
                get: function get() {
                  return n._rejectOnCancel;
                },
                set: function set(e) {
                  n._rejectOnCancel = e;
                }
              }
            }), t(function (t) {
              n._isPending = !1, e(t);
            }, function (e) {
              n._isPending = !1, r(e);
            }, o);
          });
        }
        return o(e, null, [{
          key: "fn",
          value: function value(t) {
            return function () {
              for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
                r[o] = arguments[o];
              }
              return new e(function (e, n, o) {
                r.push(o), t.apply(void 0, r).then(e, n);
              });
            };
          }
        }]), o(e, [{
          key: "then",
          value: function value(e, t) {
            return this._promise.then(e, t);
          }
        }, {
          key: "catch",
          value: function value(e) {
            return this._promise.catch(e);
          }
        }, {
          key: "finally",
          value: function value(e) {
            return this._promise.finally(e);
          }
        }, {
          key: "cancel",
          value: function value(e) {
            if (this._isPending && !this._isCanceled) {
              if (this._cancelHandlers.length > 0) try {
                var t,
                  n = u(this._cancelHandlers);
                try {
                  for (n.s(); !(t = n.n()).done;) {
                    (0, t.value)();
                  }
                } catch (e) {
                  n.e(e);
                } finally {
                  n.f();
                }
              } catch (e) {
                this._reject(e);
              }
              this._isCanceled = !0, this._rejectOnCancel && this._reject(new l(e));
            }
          }
        }, {
          key: "isCanceled",
          get: function get() {
            return this._isCanceled;
          }
        }]), e;
      }();
    Object.setPrototypeOf(d.prototype, Promise.prototype), e.exports = d, e.exports.CancelError = l;
  }, function (e, t) {
    function n() {}
    n.prototype = {
      on: function on(e, t, n) {
        var r = this.e || (this.e = {});
        return (r[e] || (r[e] = [])).push({
          fn: t,
          ctx: n
        }), this;
      },
      once: function once(e, t, n) {
        var r = this;
        function o() {
          r.off(e, o), t.apply(n, arguments);
        }
        return o._ = t, this.on(e, o, n);
      },
      emit: function emit(e) {
        for (var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), r = 0, o = n.length; r < o; r++) {
          n[r].fn.apply(n[r].ctx, t);
        }
        return this;
      },
      off: function off(e, t) {
        var n = this.e || (this.e = {}),
          r = n[e],
          o = [];
        if (r && t) for (var i = 0, a = r.length; i < a; i++) {
          r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
        }
        return o.length ? n[e] = o : delete n[e], this;
      }
    }, e.exports = n;
  }]);
});